webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return firebaseAuth; });
/* unused harmony export firebaseDb */
/* unused harmony export firebaseStatus */
/* harmony export (immutable) */ __webpack_exports__["c"] = signInWithGoogle;
/* harmony export (immutable) */ __webpack_exports__["b"] = signUpWithEmail;
/* harmony export (immutable) */ __webpack_exports__["g"] = signInWithEmail;
/* harmony export (immutable) */ __webpack_exports__["f"] = sendPWResetEmail;
/* harmony export (immutable) */ __webpack_exports__["a"] = isFirebaseEmailUser;
/* harmony export (immutable) */ __webpack_exports__["d"] = fbDeleteAcc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_store__ = __webpack_require__(35);






var firebaseApp = __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.initializeApp({
  apiKey: 'AIzaSyDbZSXOKXxwar2g4PhKHkOnuIP2PEBGTa4',
  authDomain: 'flipcards-e7350.firebaseapp.com',
  databaseURL: 'https://flipcards-e7350.firebaseio.com',
  projectId: 'flipcards-e7350',
  storageBucket: 'flipcards-e7350.appspot.com',
  messagingSenderId: '502605709118'
});

var GoogleProvider = new __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.auth.GoogleAuthProvider();

var firebaseAuth = firebaseApp.auth();

var firebaseDb = firebaseApp.database();

var firebaseStatus = { authed: false, user: null };

function signInWithGoogle() {
  return firebaseAuth.signInWithPopup(GoogleProvider);
}

function signUpWithEmail(email, password) {
  return firebaseAuth.createUserWithEmailAndPassword(email, password);
}

function signInWithEmail(email, password) {
  return firebaseAuth.signInWithEmailAndPassword(email, password);
}

function sendPWResetEmail(email) {
  return firebaseAuth.sendPasswordResetEmail(email);
}

function isFirebaseEmailUser() {
  // TODO implement
  return false;
}

function fbDeleteAcc() {
  if (!firebaseStatus.authed) {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(new Error('Not authenticated to firebase'));
  }
  return firebaseDb.ref('/users/' + firebaseStatus.user.uid).remove().then(function () {
    return firebaseStatus.user.delete();
  });
}

// firebase to vuex connection

var deactivateDownSync = null;

firebaseAuth.onAuthStateChanged(function (user) {
  deactivateDownSync && deactivateDownSync();
  firebaseStatus.authed = !!user;
  firebaseStatus.user = user;
  __WEBPACK_IMPORTED_MODULE_3__state_store__["a" /* default */].dispatch('user/firebaseAuthChanged', user);
  if (user) {
    if (__WEBPACK_IMPORTED_MODULE_3__state_store__["a" /* default */].state.user.waitingToMakeOnline) {
      syncAllDataUp(user);
      __WEBPACK_IMPORTED_MODULE_3__state_store__["a" /* default */].commit('user/setWaitingToMakeOnline', false);
    }
    deactivateDownSync = activateDownSync(user.uid);
  }
});

firebaseDb.ref('.info/connected').on('value', function (val) {
  __WEBPACK_IMPORTED_MODULE_3__state_store__["a" /* default */].commit('user/setFbConnected', val);
});

function syncAllDataUp(user) {
  var decks = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(__WEBPACK_IMPORTED_MODULE_3__state_store__["a" /* default */].state.data.decks));
  for (var deckId in decks) {
    delete decks[deckId]['.key'];
    for (var cardId in decks[deckId].cards) {
      delete decks[deckId].cards[cardId]['.key'];
    }
  }
  firebaseDb.ref('/users/' + user.uid + '/decks').set(decks);
}

function syncAllDataDown(fbDecks) {
  if (!__WEBPACK_IMPORTED_MODULE_3__state_store__["a" /* default */].state.user.fbConnected) {
    return;
  }
  try {
    var decks = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(fbDecks));
    for (var deckId in decks) {
      decks[deckId]['.key'] = deckId;
      for (var cardId in decks[deckId].cards) {
        decks[deckId].cards[cardId]['.key'] = cardId;
      }
      if (!decks[deckId].cards) {
        decks[deckId].cards = {};
      }
    }
    __WEBPACK_IMPORTED_MODULE_3__state_store__["a" /* default */].dispatch('data/importDecks', decks || {});
  } catch (e) {}
}

function activateDownSync(userId) {
  return firebaseDb.ref('/users/' + userId + '/decks').on('value', function (val) {
    syncAllDataDown(val);
  });
}

__WEBPACK_IMPORTED_MODULE_3__state_store__["a" /* default */].subscribe(function (mutation, state) {
  if (mutation.type.substring(0, 4) === 'data' && mutation.type !== 'data/setDecks' && firebaseStatus.authed && firebaseStatus.user.uid === state.user.userId) {
    syncAllDataUp(firebaseStatus.user);
  }
});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = bindToTopbar;
/* harmony export (immutable) */ __webpack_exports__["a"] = bindToPage;
var tbListener = null;
var pListener = null;

function bindToTopbar(o) {
  tbListener = o;
  return {
    unbind: function unbind() {
      tbListener = null;
    },
    backPressed: function backPressed() {
      pListener && pListener.backPressed && pListener.backPressed();
    },
    buttonPressed: function buttonPressed(btnId) {
      pListener && pListener.buttonPressed && pListener.buttonPressed(btnId);
    },
    contextualCancelled: function contextualCancelled() {
      pListener && pListener.contextualCancel && pListener.contextualCancel();
    }
  };
}

function bindToPage(o) {
  pListener = o;
  return {
    unbind: function unbind() {
      pListener = null;
    },
    setItems: function setItems(items) {
      tbListener && tbListener.items(items);
    },
    setBackEnabled: function setBackEnabled(enabled) {
      tbListener && tbListener.backEnabled(enabled);
    },
    setContextual: function setContextual(enabled) {
      tbListener && tbListener.contextual(enabled);
    },
    setContextualTitle: function setContextualTitle(title) {
      tbListener && tbListener.contextualTitle(title);
    }
  };
}

// topbar binding
/* {items(array), backEnabled(bool)} => {unbind(), backPressed(), buttonPressed(id)} */
// page binding
/* {backPressed(), buttonPressed(id)} => {unbind(), setItems(array), setBackEnabled(bool)} */

/***/ }),
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(167)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(109),
  /* template */
  __webpack_require__(290),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(168)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(110),
  /* template */
  __webpack_require__(291),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__user__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data__ = __webpack_require__(94);






__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* default */].Store({
  modules: {
    user: __WEBPACK_IMPORTED_MODULE_2__user__["a" /* default */],
    data: __WEBPACK_IMPORTED_MODULE_3__data__["a" /* default */]
  }
});
/* harmony default export */ __webpack_exports__["a"] = (store);

/* localstorage stuff */
initFromLS();
function initFromLS() {
  // load user from ls
  store.dispatch('user/loadFromLS');
  // load data from ls
  store.dispatch('data/loadFromLS');
}

/***/ }),
/* 36 */,
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return USER_STATES; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

var USER_STATES = {
  NO_USER: 0,
  NEEDS_SIGNIN: 1,
  SIGNED_IN: 2
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    userId: null,
    user: null,
    status: USER_STATES.NO_USER,
    fbConnected: false,
    waitingToMakeOnline: false
  },
  mutations: {
    setUser: function setUser(state, payload) {
      state.userId = payload.userId;
      state.user = payload.user;
      state.status = payload.status || (payload.user.isLocal ? USER_STATES.SIGNED_IN : USER_STATES.NEEDS_SIGNIN);
    },
    setStatus: function setStatus(state, status) {
      state.status = status;
    },
    signOut: function signOut(state) {
      state.userId = null;
      state.user = null;
      state.status = USER_STATES.NO_USER;
      state.waitingToMakeOnline = false;
    },
    setFbConnected: function setFbConnected(state, connected) {
      state.fbConnected = connected;
    },
    setWaitingToMakeOnline: function setWaitingToMakeOnline(state, waiting) {
      state.waitingToMakeOnline = waiting;
    }
  },
  actions: {
    loadFromLS: function loadFromLS(_ref) {
      var commit = _ref.commit,
          state = _ref.state;

      var lsAcc = localStorage.getItem('userAccount');
      if (!lsAcc) {
        return;
      }
      var acc = JSON.parse(lsAcc);
      commit('setUser', acc);
    },
    loadOrCreateLocal: function loadOrCreateLocal(_ref2) {
      var commit = _ref2.commit,
          dispatch = _ref2.dispatch,
          state = _ref2.state;

      var lsAcc = localStorage.getItem('userAccount');
      if (!lsAcc || !lsAcc.user.isLocal) {
        commit('setUser', { userId: 'local', user: { isLocal: true } });
        localStorage.setItem('userAccount', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ userId: 'local', user: { isLocal: true } }));
      } else {
        var acc = JSON.parse(lsAcc);
        commit('setUser', acc);
      }
      dispatch('data/loadFromLS', null, { root: true });
    },
    saveToLS: function saveToLS(_ref3) {
      var state = _ref3.state;

      if (!state.user) {
        return;
      }
      localStorage.setItem('userAccount', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ userId: state.userId, user: state.user }));
    },
    signOut: function signOut(_ref4) {
      var state = _ref4.state,
          commit = _ref4.commit,
          dispatch = _ref4.dispatch;

      commit('signOut');
      dispatch('data/signOut', null, { root: true });
      localStorage.removeItem('userAccount');
    },
    firebaseAuthChanged: function firebaseAuthChanged(_ref5, fbUser) {
      var commit = _ref5.commit,
          dispatch = _ref5.dispatch,
          state = _ref5.state;

      if (fbUser === null && state.user && !state.user.isLocal) {
        dispatch('signOut');
      } else if (fbUser) {
        commit('setUser', { userId: fbUser.uid, user: { isLocal: false }, status: USER_STATES.SIGNED_IN });
        dispatch('saveToLS');
        dispatch('data/loadFromLS', null, { root: true });
      }
    }
  }
});

/***/ }),
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_store__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__state_user__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Frontpage__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Frontpage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Frontpage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Signin__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Signin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Signin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Signup__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Signup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Signup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_PWReset__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_PWReset___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_PWReset__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Shell__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Shell___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Shell__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Home__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Settings__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_Settings__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Deck__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Deck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_Deck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Card__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_Card__);

















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'frontpage',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Frontpage___default.a,
    meta: { needAuth: false, noAuthRedirect: true }
  }, {
    path: '/signup',
    name: 'signup',
    component: __WEBPACK_IMPORTED_MODULE_6__components_Signup___default.a,
    meta: { needAuth: false }
  }, {
    path: '/signin',
    name: 'signin',
    component: __WEBPACK_IMPORTED_MODULE_5__components_Signin___default.a,
    meta: { needAuth: false }
  }, {
    path: '/pwreset',
    name: 'pwreset',
    component: __WEBPACK_IMPORTED_MODULE_7__components_PWReset___default.a,
    meta: { needAuth: false }
  }, {
    path: '/app',
    name: 'app',
    component: __WEBPACK_IMPORTED_MODULE_8__components_Shell___default.a,
    meta: { needAuth: true },
    children: [{
      path: 'home',
      name: 'home',
      component: __WEBPACK_IMPORTED_MODULE_9__components_Home___default.a,
      meta: { needAuth: true }
    }, {
      path: 'settings',
      name: 'settings',
      component: __WEBPACK_IMPORTED_MODULE_10__components_Settings___default.a,
      meta: { needAuth: true }
    }, {
      path: 'deck/:deckId',
      name: 'deck',
      props: true,
      component: __WEBPACK_IMPORTED_MODULE_11__components_Deck___default.a,
      meta: { needAuth: true }
    }, {
      path: 'deck/:deckId/:cardId',
      name: 'card',
      props: true,
      component: __WEBPACK_IMPORTED_MODULE_12__components_Card___default.a,
      meta: { needAuth: true }
    }]
  }, {
    path: '*',
    name: 'fallback',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Frontpage___default.a,
    meta: { needAuth: false }
  }]
});

/* harmony default export */ __webpack_exports__["a"] = (router);

var originalRoute = null;

router.beforeResolve(function (to, from, next) {
  if (to.meta.needAuth && __WEBPACK_IMPORTED_MODULE_2__state_store__["a" /* default */].state.user.status !== __WEBPACK_IMPORTED_MODULE_3__state_user__["b" /* USER_STATES */].SIGNED_IN) {
    originalRoute = { path: to.path };
    next({ name: 'frontpage' });
  } else if (!to.meta.needAuth && __WEBPACK_IMPORTED_MODULE_2__state_store__["a" /* default */].state.user.status === __WEBPACK_IMPORTED_MODULE_3__state_user__["b" /* USER_STATES */].SIGNED_IN) {
    next(originalRoute || { name: 'home' });
  } else {
    next();
  }
});

__WEBPACK_IMPORTED_MODULE_2__state_store__["a" /* default */].watch(function (state) {
  return state.user.status;
}, function (status) {
  if (status === __WEBPACK_IMPORTED_MODULE_3__state_user__["b" /* USER_STATES */].SIGNED_IN && !router.currentRoute.meta.needAuth) {
    router.replace(originalRoute || { name: 'home' });
  } else if (status !== __WEBPACK_IMPORTED_MODULE_3__state_user__["b" /* USER_STATES */].SIGNED_IN && router.currentRoute.meta.needAuth) {
    router.replace({ name: 'frontpage' });
  }
  if (status !== __WEBPACK_IMPORTED_MODULE_3__state_user__["b" /* USER_STATES */].SIGNED_IN) {
    originalRoute = null;
  }
});

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(163)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(97),
  /* template */
  __webpack_require__(286),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_ripple_directive__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__state_store__ = __webpack_require__(35);







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].directive('ripple', __WEBPACK_IMPORTED_MODULE_1_vue_ripple_directive__["a" /* default */]);

// ls and version init
localStorage.setItem('version', '1');

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_4__state_store__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_2__App___default.a);
  }
});

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_IdGenerator__ = __webpack_require__(95);






/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    decks: {},
    shuffledCardIds: {}
  },
  getters: {
    decksAsArray: function decksAsArray(state) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(state.decks).sort(function (deckA, deckB) {
        return deckA.name > deckB.name ? 1 : -1;
      });
    },

    cardsOfDeck: function cardsOfDeck(state) {
      return function (deckId) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(state.decks[deckId].cards).sort(function (cardA, cardB) {
          return cardA.title.localeCompare(cardB.title);
        });
      };
    },
    navIds: function navIds(state, getters) {
      return function (deckId, cardId, shuffle) {
        var ret = { prev: null, next: null };
        var found = -2;
        var cardIdList = shuffle ? state.shuffledCardIds[deckId] : getters.cardsOfDeck(deckId).map(function (card) {
          return card['.key'];
        });
        cardIdList.some(function (card, index) {
          if (card === cardId) {
            found = index;
          } else if (found === index - 1) {
            ret.next = card;
            return true;
          } else {
            ret.prev = card;
          }
          return false;
        });
        return ret;
      };
    }
  },
  mutations: {
    setDecks: function setDecks(state, decks) {
      __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state, 'decks', decks);
    },
    addDeck: function addDeck(state, _ref) {
      var deck = _ref.deck,
          key = _ref.key;

      __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state.decks, key, deck);
    },
    removeDeck: function removeDeck(state, key) {
      __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].delete(state.decks, key);
    },
    addCard: function addCard(state, _ref2) {
      var deckId = _ref2.deckId,
          key = _ref2.key,
          card = _ref2.card;

      __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(state.decks[deckId].cards, key, card);
    },
    removeCard: function removeCard(state, _ref3) {
      var deckId = _ref3.deckId,
          cardId = _ref3.cardId;

      var order = state.decks[deckId].cards[cardId].order;
      __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].delete(state.decks[deckId].cards, cardId);
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(state.decks[deckId].cards).filter(function (card) {
        return card.order > order;
      }).forEach(function (card) {
        card.order = card.order - 1;
      });
    },
    saveCard: function saveCard(state, _ref4) {
      var deckId = _ref4.deckId,
          cardId = _ref4.cardId,
          title = _ref4.title,
          color = _ref4.color,
          front = _ref4.front,
          back = _ref4.back;

      var card = state.decks[deckId].cards[cardId];
      card.title = title;
      card.color = color;
      card.front = front;
      card.back = back;
    },
    shuffleDeck: function shuffleDeck(state, deckId) {
      var a = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(state.decks[deckId].cards).map(function (card) {
        return card['.key'];
      });
      for (var i = a.length; i; i--) {
        var j = Math.floor(Math.random() * i);
        var x = a[i - 1];
        a[i - 1] = a[j];
        a[j] = x;
      }
      state.shuffledCardIds[deckId] = a;
    }
  },
  actions: {
    loadFromLS: function loadFromLS(_ref5) {
      var commit = _ref5.commit,
          state = _ref5.state,
          rootState = _ref5.rootState;

      if (!rootState.user.userId) {
        return;
      }
      var lsData = localStorage.getItem(rootState.user.userId);
      if (!lsData) {
        return;
      }
      commit('setDecks', JSON.parse(lsData));
    },
    saveToLS: function saveToLS(_ref6) {
      var state = _ref6.state,
          rootState = _ref6.rootState;

      if (!rootState.user.userId) {
        return;
      }
      localStorage.setItem(rootState.user.userId, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(state.decks));
    },
    signOut: function signOut(_ref7) {
      var commit = _ref7.commit;

      commit('setDecks', {});
    },
    importDecks: function importDecks(_ref8, decks) {
      var commit = _ref8.commit,
          dispatch = _ref8.dispatch;

      commit('setDecks', decks);
      dispatch('saveToLS');
    },
    createDeck: function createDeck(_ref9, payload) {
      var dispatch = _ref9.dispatch,
          commit = _ref9.commit;

      var deckId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_IdGenerator__["a" /* default */])();
      commit('addDeck', { deck: { '.key': deckId, name: payload.name, defaultColor: '#ffed96', cards: {} }, key: deckId });
      dispatch('saveToLS');
    },
    deleteDeck: function deleteDeck(_ref10, deckId) {
      var dispatch = _ref10.dispatch,
          commit = _ref10.commit;

      commit('removeDeck', deckId);
      dispatch('saveToLS');
    },
    createCard: function createCard(_ref11, payload) {
      var dispatch = _ref11.dispatch,
          commit = _ref11.commit,
          state = _ref11.state,
          getters = _ref11.getters;

      var cardId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_IdGenerator__["a" /* default */])();
      var color = payload.color || state.decks[payload.deckId].defaultColor;
      commit('addCard', { card: { '.key': cardId, order: getters.cardsOfDeck(payload.deckId).length, title: payload.title, color: color, front: '', back: '' }, key: cardId, deckId: payload.deckId });
      dispatch('saveToLS');
    },
    deleteCard: function deleteCard(_ref12, _ref13) {
      var dispatch = _ref12.dispatch,
          commit = _ref12.commit;
      var deckId = _ref13.deckId,
          cardId = _ref13.cardId;

      commit('removeCard', { deckId: deckId, cardId: cardId });
      dispatch('saveToLS');
    },
    saveCard: function saveCard(_ref14, payload) {
      var dispatch = _ref14.dispatch,
          commit = _ref14.commit;

      commit('saveCard', payload);
      dispatch('saveToLS');
    }
  }
});

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*eslint-disable */
/**
 * Fancy ID generator that creates 20-character string identifiers with the following properties:
 *
 * 1. They're based on timestamp so that they sort *after* any existing ids.
 * 2. They contain 72-bits of random data after the timestamp so that IDs won't collide with other clients' IDs.
 * 3. They sort *lexicographically* (so the timestamp is converted to characters that will sort properly).
 * 4. They're monotonically increasing.  Even if you generate more than one in the same timestamp, the
 *    latter ones will sort after the former ones.  We do this by using the previous random bits
 *    but "incrementing" them by 1 (only in the case of a timestamp collision).
 */
/* harmony default export */ __webpack_exports__["a"] = ((function () {
  // Modeled after base64 web-safe chars, but ordered by ASCII.
  var PUSH_CHARS = '-0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ_abcdefghijklmnopqrstuvwxyz';

  // Timestamp of last push, used to prevent local collisions if you push twice in one ms.
  var lastPushTime = 0;

  // We generate 72-bits of randomness which get turned into 12 characters and appended to the
  // timestamp to prevent collisions with other clients.  We store the last characters we
  // generated because in the event of a collision, we'll use those same characters except
  // "incremented" by one.
  var lastRandChars = [];

  return function () {
    var now = new Date().getTime();
    var duplicateTime = now === lastPushTime;
    lastPushTime = now;

    var timeStampChars = new Array(8);
    for (var i = 7; i >= 0; i--) {
      timeStampChars[i] = PUSH_CHARS.charAt(now % 64);
      // NOTE: Can't use << here because javascript will convert to int and lose the upper bits.
      now = Math.floor(now / 64);
    }
    if (now !== 0) throw new Error('We should have converted the entire timestamp.');

    var id = timeStampChars.join('');

    if (!duplicateTime) {
      for (i = 0; i < 12; i++) {
        lastRandChars[i] = Math.floor(Math.random() * 64);
      }
    } else {
      // If the timestamp hasn't changed since last push, use the same random number, except incremented by 1.
      for (i = 11; i >= 0 && lastRandChars[i] === 63; i--) {
        lastRandChars[i] = 0;
      }
      lastRandChars[i]++;
    }
    for (i = 0; i < 12; i++) {
      id += PUSH_CHARS.charAt(lastRandChars[i]);
    }
    if (id.length != 20) throw new Error('Length should be 20.');

    return id;
  };
})());

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(11);


var keyEventHub = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();

/* harmony default export */ __webpack_exports__["a"] = (keyEventHub);

window.addEventListener('keydown', function (event) {
  if (event.which === 83 && (navigator.platform.match('Mac') ? event.metaKey : event.ctrlKey) || event.which === 19) {
    keyEventHub.$emit('save');
    event.preventDefault();
    return false;
  } else if (event.which === 38 || event.which === 40) {
    keyEventHub.$emit('flip');
    event.preventDefault();
    return false;
  } else if (event.which === 69 && (navigator.platform.match('Mac') ? event.metaKey : event.ctrlKey)) {
    keyEventHub.$emit('edit');
    event.preventDefault();
    return false;
  } else if (event.which === 37) {
    keyEventHub.$emit('prev');
    event.preventDefault();
    return false;
  } else if (event.which === 39) {
    keyEventHub.$emit('next');
    event.preventDefault();
    return false;
  } else {
    return true;
  }
});

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_markdown__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_markdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_markdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Cardview__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Cardview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Cardview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Tooltip__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_keyEvents__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_topbarAdapter__ = __webpack_require__(14);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









var topbarDispatcher = null;
var TOPBAR_ITEMS = {
  EDIT: 0,
  SAVE: 1
};

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['deckId', 'cardId'],
  components: {
    'Cardview': __WEBPACK_IMPORTED_MODULE_2__components_Cardview___default.a,
    'Markdown': __WEBPACK_IMPORTED_MODULE_1_vue_markdown___default.a,
    'Tooltip': __WEBPACK_IMPORTED_MODULE_3__components_Tooltip___default.a
  },
  data: function data() {
    return {
      editing: false,
      eTitle: '',
      eColor: '',
      eFront: '',
      eBack: '',
      backStack: 1,
      backDefault: false
    };
  },

  computed: {
    card: function card() {
      return this.$store.state.data.decks[this.deckId].cards[this.cardId];
    },
    navIds: function navIds() {
      return this.$store.getters['data/navIds'](this.deckId, this.cardId, this.$route.query.shuffle);
    },
    cardcolor: function cardcolor() {
      return this.editing ? this.eColor : this.card.color;
    }
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_4__util_keyEvents__["a" /* default */].$on('flip', function () {
      return _this.$refs.card && _this.$refs.card.flip();
    });
    __WEBPACK_IMPORTED_MODULE_4__util_keyEvents__["a" /* default */].$on('edit', function () {
      return !_this.editing && _this.toggleEditing();
    });
    __WEBPACK_IMPORTED_MODULE_4__util_keyEvents__["a" /* default */].$on('save', function () {
      return _this.editing && _this.toggleEditing();
    });
    __WEBPACK_IMPORTED_MODULE_4__util_keyEvents__["a" /* default */].$on('prev', this.toPrev);
    __WEBPACK_IMPORTED_MODULE_4__util_keyEvents__["a" /* default */].$on('next', this.toNext);
    topbarDispatcher = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_topbarAdapter__["a" /* bindToPage */])({
      backPressed: this.backPressed,
      buttonPressed: this.topbarBtnPressed
    });
    topbarDispatcher.setBackEnabled(true);
    this.topbarDisplayEdit();
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_4__util_keyEvents__["a" /* default */].$off('flip');
    __WEBPACK_IMPORTED_MODULE_4__util_keyEvents__["a" /* default */].$off('prev');
    __WEBPACK_IMPORTED_MODULE_4__util_keyEvents__["a" /* default */].$off('next');
    __WEBPACK_IMPORTED_MODULE_4__util_keyEvents__["a" /* default */].$off('save');
    __WEBPACK_IMPORTED_MODULE_4__util_keyEvents__["a" /* default */].$off('edit');
  },

  watch: {
    '$route': function $route() {
      this.backStack++;
    },
    backDefault: function backDefault(newVal) {
      this.$router.push({
        name: this.$route.name,
        params: this.$route.params,
        query: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.$route.query, { back: newVal })
      });
    }
  },
  methods: {
    backPressed: function backPressed() {
      this.$router.go(-this.backStack);
    },
    topbarBtnPressed: function topbarBtnPressed(id) {
      switch (id) {
        case TOPBAR_ITEMS.EDIT:
          this.toggleEditing();
          break;
        case TOPBAR_ITEMS.SAVE:
          this.toggleEditing();
      }
    },
    topbarDisplayEdit: function topbarDisplayEdit() {
      topbarDispatcher.setItems([{
        id: TOPBAR_ITEMS.EDIT,
        text: 'Edit',
        shortcut: 'CTRL-E',
        svgPath: 'M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z'
      }]);
    },
    topbarDisplaySave: function topbarDisplaySave() {
      topbarDispatcher.setItems([{
        id: TOPBAR_ITEMS.SAVE,
        text: 'Save',
        shortcut: 'CTRL-S',
        svgPath: 'M17 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V7l-4-4zm-5 16c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm3-10H5V5h10v4z'
      }]);
    },
    toPrev: function toPrev() {
      this.navIds.prev && this.$router.push({
        name: 'card',
        params: { deckId: this.deckId, cardId: this.navIds.prev },
        query: this.$route.query
      });
    },
    toNext: function toNext() {
      this.navIds.next && this.$router.push({
        name: 'card',
        params: { deckId: this.deckId, cardId: this.navIds.next },
        query: this.$route.query
      });
    },
    toggleEditing: function toggleEditing() {
      var _this2 = this;

      if (!this.editing) {
        this.eTitle = this.card.title;
        this.eColor = this.card.color;
        this.eFront = this.card.front;
        this.eBack = this.card.back;
        this.editing = true;
        this.topbarDisplaySave();
        setTimeout(function () {
          return _this2.$refs.etitle.focus();
        }, 100);
      } else {
        this.$store.dispatch('data/saveCard', {
          cardId: this.cardId,
          deckId: this.deckId,
          title: this.eTitle,
          color: this.eColor,
          front: this.eFront,
          back: this.eBack
        });
        this.editing = false;
        this.topbarDisplayEdit();
      }
    }
  }
});

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Tooltip__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Tooltip__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Tooltip: __WEBPACK_IMPORTED_MODULE_0__components_Tooltip___default.a
  },
  props: ['title', 'color', 'front', 'back'],
  data: function data() {
    return {
      viewBack: false
    };
  },

  methods: {
    flip: function flip() {
      this.viewBack = !this.viewBack;
    },
    toBack: function toBack() {
      this.viewBack = true;
    },
    toFront: function toFront() {
      this.viewBack = false;
    }
  },
  watch: {
    '$route': function $route(to, from) {
      if (to.query.back) {
        this.toBack();
      } else {
        this.toFront();
      }
    }
  }
});

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_topbarAdapter__ = __webpack_require__(14);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var topbarDispatcher = null;
var TOPBAR_ITEMS = {
  ADD_CARD: 0,
  SHUFFLE: 1,
  DELETE: 2
};

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['deckId'],
  data: function data() {
    return {
      selectedCards: {}
    };
  },

  computed: {
    deck: function deck() {
      return this.$store.state.data.decks[this.deckId];
    },
    cards: function cards() {
      return this.$store.getters['data/cardsOfDeck'](this.deckId);
    },
    selectedCardCount: function selectedCardCount() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.selectedCards).length;
    }
  },
  mounted: function mounted() {
    topbarDispatcher = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_topbarAdapter__["a" /* bindToPage */])({
      backPressed: this.backPressed,
      buttonPressed: this.topbarBtnPressed,
      contextualCancel: this.contextualCancel
    });
    this.setNormalTopbar();
  },

  methods: {
    setNormalTopbar: function setNormalTopbar() {
      topbarDispatcher.setContextual(false);
      topbarDispatcher.setBackEnabled(true);
      topbarDispatcher.setItems([{
        id: TOPBAR_ITEMS.SHUFFLE,
        text: 'Shuffle',
        svgPath: 'M14.83,13.41L13.42,14.82L16.55,17.95L14.5,20H20V14.5L17.96,16.54L14.83,13.41M14.5,4L16.54,6.04L4,18.59L5.41,20L17.96,7.46L20,9.5V4M10.59,9.17L5.41,4L4,5.41L9.17,10.58L10.59,9.17Z'
      }, {
        id: TOPBAR_ITEMS.ADD_CARD,
        text: 'Add Card',
        svgPath: 'M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z'
      }]);
    },
    setContextualTopbar: function setContextualTopbar() {
      topbarDispatcher.setContextualTitle('0 selected');
      topbarDispatcher.setContextual(true);
      topbarDispatcher.setItems([{
        id: TOPBAR_ITEMS.DELETE,
        text: 'Delete Cards',
        svgPath: 'M19,4H15.5L14.5,3H9.5L8.5,4H5V6H19M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19Z'
      }]);
    },
    contextualCancel: function contextualCancel() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.selectedCards).forEach(function (key) {
        return _this.$delete(_this.selectedCards, key);
      });
    },
    backPressed: function backPressed() {
      this.$router.go(-1);
    },
    topbarBtnPressed: function topbarBtnPressed(id) {
      switch (id) {
        case TOPBAR_ITEMS.DELETE:
          this.deleteSelectedCards();
          this.setNormalTopbar();
          break;
        case TOPBAR_ITEMS.SHUFFLE:
          this.shuffle();
          break;
        case TOPBAR_ITEMS.ADD_CARD:
          this.addCard();
      }
    },
    deleteSelectedCards: function deleteSelectedCards() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.selectedCards).forEach(function (cardId) {
        return _this2.deleteCard(cardId);
      });
    },
    selectCard: function selectCard(cardId) {
      this.$set(this.selectedCards, cardId, true);
    },
    deselectCard: function deselectCard(cardId) {
      this.$delete(this.selectedCards, cardId);
    },
    shuffle: function shuffle() {
      this.$store.commit('data/shuffleDeck', this.deckId);
      this.$router.push({
        name: 'card',
        params: { deckId: this.deckId, cardId: this.$store.state.data.shuffledCardIds[this.deckId][0] },
        query: { shuffle: true }
      });
    },
    addCard: function addCard() {
      this.$store.dispatch('data/createCard', { title: 'new Card', deckId: this.deckId });
    },
    deleteCard: function deleteCard(cardId) {
      this.$store.dispatch('data/deleteCard', { deckId: this.deckId, cardId: cardId });
    }
  },
  watch: {
    selectedCardCount: function selectedCardCount(newCount, oldCount) {
      if (newCount > 0) {
        if (oldCount === 0) {
          this.setContextualTopbar();
        }
        topbarDispatcher.setContextualTitle(newCount + ' selected');
      } else if (newCount === 0 && oldCount > 0) {
        this.setNormalTopbar();
      }
    }
  }
});

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Tooltip__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Tooltip__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Tooltip: __WEBPACK_IMPORTED_MODULE_0__components_Tooltip___default.a
  },
  data: function data() {
    return {};
  },

  methods: {
    signInLocally: function signInLocally() {
      this.$store.dispatch('user/loadOrCreateLocal');
      this.$router.replace('/home');
    }
  }
});

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Modal__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_topbarAdapter__ = __webpack_require__(14);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var topbarDispatcher = null;
var TOPBAR_ITEMS = {
  NEW_DECK: 0,
  SETTINGS: 1
};

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'Modal': __WEBPACK_IMPORTED_MODULE_1__components_Modal___default.a
  },
  data: function data() {
    return {
      createDeckModalOpen: false,
      deleteDeckModalOpen: false,
      toBeDeletedName: null,
      toBeDeletedKey: null,
      newDeckName: ''
    };
  },

  computed: {
    userIsLocal: function userIsLocal() {
      return this.$store.state.user.user.isLocal;
    },
    decks: function decks() {
      var _this = this;

      return this.$store.getters['data/decksAsArray'].map(function (deck) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, deck, {
          cardCount: _this.$store.getters['data/cardsOfDeck'](deck['.key']).length
        });
      });
    }
  },
  mounted: function mounted() {
    topbarDispatcher = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_topbarAdapter__["a" /* bindToPage */])({
      buttonPressed: this.topbarBtnPressed
    });
    topbarDispatcher.setBackEnabled(false);
    topbarDispatcher.setItems([{
      id: TOPBAR_ITEMS.NEW_DECK,
      text: 'New Deck',
      svgPath: 'M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10h-4v4h-2v-4H7v-2h4V7h2v4h4v2z'
    }, {
      id: TOPBAR_ITEMS.SETTINGS,
      text: 'Settings',
      svgPath: 'M19.43 12.98c.04-.32.07-.64.07-.98s-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46c-.12-.22-.39-.3-.61-.22l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65C14.46 2.18 14.25 2 14 2h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1c-.23-.09-.49 0-.61.22l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98s.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46c.12.22.39.3.61.22l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.23.09.49 0 .61-.22l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.65zM12 15.5c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5z'
    }]);
  },

  methods: {
    topbarBtnPressed: function topbarBtnPressed(id) {
      var _this2 = this;

      switch (id) {
        case TOPBAR_ITEMS.NEW_DECK:
          this.createDeckModalOpen = true;
          setTimeout(function () {
            return _this2.$refs.nameInput && _this2.$refs.nameInput.focus();
          }, 100);
          break;
        case TOPBAR_ITEMS.SETTINGS:
          this.$router.push({ name: 'settings' });
      }
    },
    createDeck: function createDeck() {
      this.createDeckModalOpen = false;
      this.$store.dispatch('data/createDeck', { name: this.newDeckName });
      this.newDeckName = '';
    },
    openDeleteDeckModal: function openDeleteDeckModal(deck) {
      this.toBeDeletedName = deck.name;
      this.toBeDeletedKey = deck['.key'];
      this.deleteDeckModalOpen = true;
    },
    deleteDeck: function deleteDeck() {
      this.$store.dispatch('data/deleteDeck', this.toBeDeletedKey);
    },
    cancelDeleteDeck: function cancelDeleteDeck() {
      this.deleteDeckModalOpen = false;
      this.toBeDeletedName = null;
      this.toBeDeletedKey = null;
    }
  }
});

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['open', 'title', 'cancelText', 'okText']
});

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_firebase__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Topbar__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Topbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Topbar__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'Topbar': __WEBPACK_IMPORTED_MODULE_1__components_Topbar___default.a
  },
  data: function data() {
    return {
      email: '',
      sent: false
    };
  },

  methods: {
    resetpw: function resetpw() {
      var _this = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_firebase__["f" /* sendPWResetEmail */])(this.email).then(function () {
        _this.sent = true;
      });
    }
  }
});

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_firebase__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_topbarAdapter__ = __webpack_require__(14);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      password: '',
      passwordRetype: '',
      email: '',
      isFirebaseEmailUser: false
    };
  },

  computed: {
    userIsLocal: function userIsLocal() {
      return this.$store.state.user.user.isLocal;
    },
    passwordsMatch: function passwordsMatch() {
      return this.password === this.passwordRetype;
    },
    passwordPatternMatch: function passwordPatternMatch() {
      return this.password.length >= 6;
    }
  },
  mounted: function mounted() {
    var tD = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_topbarAdapter__["a" /* bindToPage */])({
      backPressed: this.backPressed
    });
    tD.setItems([]);
    tD.setBackEnabled(true);
    this.isFirebaseEmailUser = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_firebase__["a" /* isFirebaseEmailUser */])();
  },

  methods: {
    backPressed: function backPressed() {
      this.$router.go(-1);
    },
    signup: function signup() {
      if (!this.passwordsMatch || !this.passwordPatternMatch) {
        return;
      }
      this.$store.commit('user/setWaitingToMakeOnline', true);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_firebase__["b" /* signUpWithEmail */])(this.email, this.password);
    },
    signupGoogle: function signupGoogle() {
      this.$store.commit('user/setWaitingToMakeOnline', true);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_firebase__["c" /* signInWithGoogle */])();
    },
    deleteAccount: function deleteAccount() {
      if (this.userIsLocal) {
        window.localStorage.clear();
        this.$store.commit('user/signOut');
      } else {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_firebase__["d" /* fbDeleteAcc */])().then(function () {
          window.localStorage.clear();
        });
        this.$store.commit('user/signOut');
      }
    }
  }
});

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Topbar__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Topbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Topbar__);
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'Topbar': __WEBPACK_IMPORTED_MODULE_0__components_Topbar___default.a
  },
  data: function data() {
    return {
      transitionName: 'slide-right'
    };
  },

  watch: {
    '$route': function $route(to, from) {
      var toDepth = to.path.split('/').length;
      var fromDepth = from.path.split('/').length;
      this.transitionName = toDepth >= fromDepth ? 'slide-right' : 'slide-left';
    }
  }
});

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_firebase__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Topbar__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Topbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Topbar__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'Topbar': __WEBPACK_IMPORTED_MODULE_1__components_Topbar___default.a
  },
  data: function data() {
    return {
      password: '',
      email: ''
    };
  },

  methods: {
    signin: function signin() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_firebase__["g" /* signInWithEmail */])(this.email, this.password);
    },
    signinGoogle: function signinGoogle() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_firebase__["c" /* signInWithGoogle */])();
    }
  }
});

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_firebase__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Topbar__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Topbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Topbar__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'Topbar': __WEBPACK_IMPORTED_MODULE_1__components_Topbar___default.a
  },
  data: function data() {
    return {
      password: '',
      passwordRetype: '',
      email: ''
    };
  },

  computed: {
    passwordsMatch: function passwordsMatch() {
      return this.password === this.passwordRetype;
    },
    passwordPatternMatch: function passwordPatternMatch() {
      return this.password.length >= 6;
    }
  },
  methods: {
    signup: function signup() {
      if (!this.passwordsMatch || !this.passwordPatternMatch) {
        return;
      }
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_firebase__["b" /* signUpWithEmail */])(this.email, this.password);
    },
    signupGoogle: function signupGoogle() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util_firebase__["c" /* signInWithGoogle */])();
    }
  }
});

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//

var transitionEndEventName = function () {
  var el = document.createElement('span');
  var transitions = {
    transition: 'transitionend',
    OTransition: 'oTransitionEnd',
    MozTransition: 'transitionend',
    WebkitTransition: 'webkitTransitionEnd'
  };
  for (var transition in transitions) {
    if (el.style[transition] !== undefined) {
      return transitions[transition];
    }
  }
}();

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'md-tooltip',
  props: {
    mdDirection: {
      type: String,
      default: 'bottom'
    },
    mdDelay: {
      type: String,
      default: '0'
    }
  },
  data: function data() {
    return {
      active: false,
      parentClass: null,
      transitionOff: false,
      topPosition: false,
      leftPosition: false
    };
  },
  computed: {
    classes: function classes() {
      var cssClasses = {
        'md-active': this.active,
        'md-transition-off': this.transitionOff,
        'md-tooltip-top': this.mdDirection === 'top',
        'md-tooltip-right': this.mdDirection === 'right',
        'md-tooltip-bottom': this.mdDirection === 'bottom',
        'md-tooltip-left': this.mdDirection === 'left'
      };
      if (this.parentClass) {
        cssClasses[this.parentClass] = true;
      }
      return cssClasses;
    },
    style: function style() {
      return {
        'transition-delay': this.mdDelay + 'ms',
        top: this.topPosition + 'px',
        left: this.leftPosition + 'px'
      };
    }
  },
  watch: {
    mdDirection: function mdDirection() {
      this.calculateTooltipPosition();
    }
  },
  methods: {
    removeTooltips: function removeTooltips() {
      if (this.tooltipElement.parentNode) {
        this.tooltipElement.removeEventListener(transitionEndEventName, this.removeTooltips);
        this.tooltipElement.parentNode.removeChild(this.tooltipElement);
      }
    },
    calculateTooltipPosition: function calculateTooltipPosition() {
      var position = this.parentElement.getBoundingClientRect();
      var cssPosition = {};
      switch (this.mdDirection) {
        case 'top':
          cssPosition.top = position.top - this.$el.offsetHeight;
          cssPosition.left = position.left + position.width / 2;
          break;
        case 'right':
          cssPosition.top = position.top;
          cssPosition.left = position.left + position.width;
          break;
        case 'bottom':
          cssPosition.top = position.bottom;
          cssPosition.left = position.left + position.width / 2;
          break;
        case 'left':
          cssPosition.top = position.top;
          cssPosition.left = position.left - this.$el.offsetWidth;
          break;
        default:
          console.warn('Invalid ' + this.mdDirection + ' option to md-direction option');
      }
      this.topPosition = cssPosition.top;
      this.leftPosition = cssPosition.left;
    },
    generateTooltipClasses: function generateTooltipClasses() {
      var classes = [];
      this.parentElement.classList.forEach(function (cssClass) {
        if (cssClass.indexOf('md-') >= 0 && cssClass !== 'md-active') {
          classes.push(cssClass + '-tooltip');
        }
      });
      this.parentClass = classes.join(' ');
    },
    open: function open() {
      var _this = this;

      this.removeTooltips();
      this.$nextTick(function () {
        document.body.appendChild(_this.tooltipElement);
        getComputedStyle(_this.tooltipElement).top;
        _this.transitionOff = true;
        _this.generateTooltipClasses();
        _this.calculateTooltipPosition();
        window.setTimeout(function () {
          _this.transitionOff = false;
          _this.active = true;
        }, 10);
      });
    },
    close: function close() {
      this.active = false;
      this.tooltipElement.removeEventListener(transitionEndEventName, this.removeTooltips);
      this.tooltipElement.addEventListener(transitionEndEventName, this.removeTooltips);
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$nextTick(function () {
      _this2.tooltipElement = _this2.$el;
      _this2.parentElement = _this2.tooltipElement.parentNode;
      _this2.$el.parentNode.removeChild(_this2.$el);
      _this2.parentElement.addEventListener('mouseenter', _this2.open);
      _this2.parentElement.addEventListener('focus', _this2.open);
      _this2.parentElement.addEventListener('mouseleave', _this2.close);
      _this2.parentElement.addEventListener('blur', _this2.close);
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.active = false;
    this.removeTooltips();
    if (this.parentElement) {
      this.parentElement.removeEventListener('mouseenter', this.open);
      this.parentElement.removeEventListener('focus', this.open);
      this.parentElement.removeEventListener('mouseleave', this.close);
      this.parentElement.removeEventListener('blur', this.close);
    }
  }
});

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_firebase__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_topbarAdapter__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_user__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Tooltip__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Tooltip__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var adapterDispatcher = null;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Topbar',
  components: {
    Tooltip: __WEBPACK_IMPORTED_MODULE_3__components_Tooltip___default.a
  },
  data: function data() {
    return {
      canGoBack: false,
      contextual: false,
      contextualTitle: '',
      items: [],
      menuOpen: false
    };
  },

  computed: {
    signedIn: function signedIn() {
      return this.$store.state.user.status === __WEBPACK_IMPORTED_MODULE_2__state_user__["b" /* USER_STATES */].SIGNED_IN;
    }
  },
  mounted: function mounted() {
    adapterDispatcher = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_topbarAdapter__["b" /* bindToTopbar */])({
      items: this.onItemsChanged,
      backEnabled: this.onBackEnabled,
      contextual: this.onContextual,
      contextualTitle: this.onContextualTitle
    });
  },
  destroyed: function destroyed() {
    adapterDispatcher.unbind();
  },

  methods: {
    onItemsChanged: function onItemsChanged(items) {
      this.items = items;
    },
    onBackEnabled: function onBackEnabled(enabled) {
      this.canGoBack = enabled;
    },
    onContextual: function onContextual(enabled) {
      this.contextual = enabled;
    },
    onContextualTitle: function onContextualTitle(title) {
      this.contextualTitle = title;
    },
    itemClicked: function itemClicked(id) {
      adapterDispatcher.buttonPressed(id);
      this.menuOpen = false;
    },
    signOut: function signOut() {
      this.menuOpen = false;
      __WEBPACK_IMPORTED_MODULE_0__util_firebase__["e" /* firebaseAuth */].signOut();
      this.$store.dispatch('user/signOut');
      this.$router.push('/');
    },
    goBack: function goBack() {
      if (this.contextual) {
        adapterDispatcher.contextualCancelled();
      } else if (this.canGoBack) {
        adapterDispatcher.backPressed();
      } else {
        this.$router.push({ name: this.signedIn ? 'home' : 'frontpage' });
      }
    }
  }
});

/***/ }),
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */
/***/ (function(module, exports) {

module.exports = {"Aacute":"Á","aacute":"á","Abreve":"Ă","abreve":"ă","ac":"∾","acd":"∿","acE":"∾̳","Acirc":"Â","acirc":"â","acute":"´","Acy":"А","acy":"а","AElig":"Æ","aelig":"æ","af":"⁡","Afr":"𝔄","afr":"𝔞","Agrave":"À","agrave":"à","alefsym":"ℵ","aleph":"ℵ","Alpha":"Α","alpha":"α","Amacr":"Ā","amacr":"ā","amalg":"⨿","amp":"&","AMP":"&","andand":"⩕","And":"⩓","and":"∧","andd":"⩜","andslope":"⩘","andv":"⩚","ang":"∠","ange":"⦤","angle":"∠","angmsdaa":"⦨","angmsdab":"⦩","angmsdac":"⦪","angmsdad":"⦫","angmsdae":"⦬","angmsdaf":"⦭","angmsdag":"⦮","angmsdah":"⦯","angmsd":"∡","angrt":"∟","angrtvb":"⊾","angrtvbd":"⦝","angsph":"∢","angst":"Å","angzarr":"⍼","Aogon":"Ą","aogon":"ą","Aopf":"𝔸","aopf":"𝕒","apacir":"⩯","ap":"≈","apE":"⩰","ape":"≊","apid":"≋","apos":"'","ApplyFunction":"⁡","approx":"≈","approxeq":"≊","Aring":"Å","aring":"å","Ascr":"𝒜","ascr":"𝒶","Assign":"≔","ast":"*","asymp":"≈","asympeq":"≍","Atilde":"Ã","atilde":"ã","Auml":"Ä","auml":"ä","awconint":"∳","awint":"⨑","backcong":"≌","backepsilon":"϶","backprime":"‵","backsim":"∽","backsimeq":"⋍","Backslash":"∖","Barv":"⫧","barvee":"⊽","barwed":"⌅","Barwed":"⌆","barwedge":"⌅","bbrk":"⎵","bbrktbrk":"⎶","bcong":"≌","Bcy":"Б","bcy":"б","bdquo":"„","becaus":"∵","because":"∵","Because":"∵","bemptyv":"⦰","bepsi":"϶","bernou":"ℬ","Bernoullis":"ℬ","Beta":"Β","beta":"β","beth":"ℶ","between":"≬","Bfr":"𝔅","bfr":"𝔟","bigcap":"⋂","bigcirc":"◯","bigcup":"⋃","bigodot":"⨀","bigoplus":"⨁","bigotimes":"⨂","bigsqcup":"⨆","bigstar":"★","bigtriangledown":"▽","bigtriangleup":"△","biguplus":"⨄","bigvee":"⋁","bigwedge":"⋀","bkarow":"⤍","blacklozenge":"⧫","blacksquare":"▪","blacktriangle":"▴","blacktriangledown":"▾","blacktriangleleft":"◂","blacktriangleright":"▸","blank":"␣","blk12":"▒","blk14":"░","blk34":"▓","block":"█","bne":"=⃥","bnequiv":"≡⃥","bNot":"⫭","bnot":"⌐","Bopf":"𝔹","bopf":"𝕓","bot":"⊥","bottom":"⊥","bowtie":"⋈","boxbox":"⧉","boxdl":"┐","boxdL":"╕","boxDl":"╖","boxDL":"╗","boxdr":"┌","boxdR":"╒","boxDr":"╓","boxDR":"╔","boxh":"─","boxH":"═","boxhd":"┬","boxHd":"╤","boxhD":"╥","boxHD":"╦","boxhu":"┴","boxHu":"╧","boxhU":"╨","boxHU":"╩","boxminus":"⊟","boxplus":"⊞","boxtimes":"⊠","boxul":"┘","boxuL":"╛","boxUl":"╜","boxUL":"╝","boxur":"└","boxuR":"╘","boxUr":"╙","boxUR":"╚","boxv":"│","boxV":"║","boxvh":"┼","boxvH":"╪","boxVh":"╫","boxVH":"╬","boxvl":"┤","boxvL":"╡","boxVl":"╢","boxVL":"╣","boxvr":"├","boxvR":"╞","boxVr":"╟","boxVR":"╠","bprime":"‵","breve":"˘","Breve":"˘","brvbar":"¦","bscr":"𝒷","Bscr":"ℬ","bsemi":"⁏","bsim":"∽","bsime":"⋍","bsolb":"⧅","bsol":"\\","bsolhsub":"⟈","bull":"•","bullet":"•","bump":"≎","bumpE":"⪮","bumpe":"≏","Bumpeq":"≎","bumpeq":"≏","Cacute":"Ć","cacute":"ć","capand":"⩄","capbrcup":"⩉","capcap":"⩋","cap":"∩","Cap":"⋒","capcup":"⩇","capdot":"⩀","CapitalDifferentialD":"ⅅ","caps":"∩︀","caret":"⁁","caron":"ˇ","Cayleys":"ℭ","ccaps":"⩍","Ccaron":"Č","ccaron":"č","Ccedil":"Ç","ccedil":"ç","Ccirc":"Ĉ","ccirc":"ĉ","Cconint":"∰","ccups":"⩌","ccupssm":"⩐","Cdot":"Ċ","cdot":"ċ","cedil":"¸","Cedilla":"¸","cemptyv":"⦲","cent":"¢","centerdot":"·","CenterDot":"·","cfr":"𝔠","Cfr":"ℭ","CHcy":"Ч","chcy":"ч","check":"✓","checkmark":"✓","Chi":"Χ","chi":"χ","circ":"ˆ","circeq":"≗","circlearrowleft":"↺","circlearrowright":"↻","circledast":"⊛","circledcirc":"⊚","circleddash":"⊝","CircleDot":"⊙","circledR":"®","circledS":"Ⓢ","CircleMinus":"⊖","CirclePlus":"⊕","CircleTimes":"⊗","cir":"○","cirE":"⧃","cire":"≗","cirfnint":"⨐","cirmid":"⫯","cirscir":"⧂","ClockwiseContourIntegral":"∲","CloseCurlyDoubleQuote":"”","CloseCurlyQuote":"’","clubs":"♣","clubsuit":"♣","colon":":","Colon":"∷","Colone":"⩴","colone":"≔","coloneq":"≔","comma":",","commat":"@","comp":"∁","compfn":"∘","complement":"∁","complexes":"ℂ","cong":"≅","congdot":"⩭","Congruent":"≡","conint":"∮","Conint":"∯","ContourIntegral":"∮","copf":"𝕔","Copf":"ℂ","coprod":"∐","Coproduct":"∐","copy":"©","COPY":"©","copysr":"℗","CounterClockwiseContourIntegral":"∳","crarr":"↵","cross":"✗","Cross":"⨯","Cscr":"𝒞","cscr":"𝒸","csub":"⫏","csube":"⫑","csup":"⫐","csupe":"⫒","ctdot":"⋯","cudarrl":"⤸","cudarrr":"⤵","cuepr":"⋞","cuesc":"⋟","cularr":"↶","cularrp":"⤽","cupbrcap":"⩈","cupcap":"⩆","CupCap":"≍","cup":"∪","Cup":"⋓","cupcup":"⩊","cupdot":"⊍","cupor":"⩅","cups":"∪︀","curarr":"↷","curarrm":"⤼","curlyeqprec":"⋞","curlyeqsucc":"⋟","curlyvee":"⋎","curlywedge":"⋏","curren":"¤","curvearrowleft":"↶","curvearrowright":"↷","cuvee":"⋎","cuwed":"⋏","cwconint":"∲","cwint":"∱","cylcty":"⌭","dagger":"†","Dagger":"‡","daleth":"ℸ","darr":"↓","Darr":"↡","dArr":"⇓","dash":"‐","Dashv":"⫤","dashv":"⊣","dbkarow":"⤏","dblac":"˝","Dcaron":"Ď","dcaron":"ď","Dcy":"Д","dcy":"д","ddagger":"‡","ddarr":"⇊","DD":"ⅅ","dd":"ⅆ","DDotrahd":"⤑","ddotseq":"⩷","deg":"°","Del":"∇","Delta":"Δ","delta":"δ","demptyv":"⦱","dfisht":"⥿","Dfr":"𝔇","dfr":"𝔡","dHar":"⥥","dharl":"⇃","dharr":"⇂","DiacriticalAcute":"´","DiacriticalDot":"˙","DiacriticalDoubleAcute":"˝","DiacriticalGrave":"`","DiacriticalTilde":"˜","diam":"⋄","diamond":"⋄","Diamond":"⋄","diamondsuit":"♦","diams":"♦","die":"¨","DifferentialD":"ⅆ","digamma":"ϝ","disin":"⋲","div":"÷","divide":"÷","divideontimes":"⋇","divonx":"⋇","DJcy":"Ђ","djcy":"ђ","dlcorn":"⌞","dlcrop":"⌍","dollar":"$","Dopf":"𝔻","dopf":"𝕕","Dot":"¨","dot":"˙","DotDot":"⃜","doteq":"≐","doteqdot":"≑","DotEqual":"≐","dotminus":"∸","dotplus":"∔","dotsquare":"⊡","doublebarwedge":"⌆","DoubleContourIntegral":"∯","DoubleDot":"¨","DoubleDownArrow":"⇓","DoubleLeftArrow":"⇐","DoubleLeftRightArrow":"⇔","DoubleLeftTee":"⫤","DoubleLongLeftArrow":"⟸","DoubleLongLeftRightArrow":"⟺","DoubleLongRightArrow":"⟹","DoubleRightArrow":"⇒","DoubleRightTee":"⊨","DoubleUpArrow":"⇑","DoubleUpDownArrow":"⇕","DoubleVerticalBar":"∥","DownArrowBar":"⤓","downarrow":"↓","DownArrow":"↓","Downarrow":"⇓","DownArrowUpArrow":"⇵","DownBreve":"̑","downdownarrows":"⇊","downharpoonleft":"⇃","downharpoonright":"⇂","DownLeftRightVector":"⥐","DownLeftTeeVector":"⥞","DownLeftVectorBar":"⥖","DownLeftVector":"↽","DownRightTeeVector":"⥟","DownRightVectorBar":"⥗","DownRightVector":"⇁","DownTeeArrow":"↧","DownTee":"⊤","drbkarow":"⤐","drcorn":"⌟","drcrop":"⌌","Dscr":"𝒟","dscr":"𝒹","DScy":"Ѕ","dscy":"ѕ","dsol":"⧶","Dstrok":"Đ","dstrok":"đ","dtdot":"⋱","dtri":"▿","dtrif":"▾","duarr":"⇵","duhar":"⥯","dwangle":"⦦","DZcy":"Џ","dzcy":"џ","dzigrarr":"⟿","Eacute":"É","eacute":"é","easter":"⩮","Ecaron":"Ě","ecaron":"ě","Ecirc":"Ê","ecirc":"ê","ecir":"≖","ecolon":"≕","Ecy":"Э","ecy":"э","eDDot":"⩷","Edot":"Ė","edot":"ė","eDot":"≑","ee":"ⅇ","efDot":"≒","Efr":"𝔈","efr":"𝔢","eg":"⪚","Egrave":"È","egrave":"è","egs":"⪖","egsdot":"⪘","el":"⪙","Element":"∈","elinters":"⏧","ell":"ℓ","els":"⪕","elsdot":"⪗","Emacr":"Ē","emacr":"ē","empty":"∅","emptyset":"∅","EmptySmallSquare":"◻","emptyv":"∅","EmptyVerySmallSquare":"▫","emsp13":" ","emsp14":" ","emsp":" ","ENG":"Ŋ","eng":"ŋ","ensp":" ","Eogon":"Ę","eogon":"ę","Eopf":"𝔼","eopf":"𝕖","epar":"⋕","eparsl":"⧣","eplus":"⩱","epsi":"ε","Epsilon":"Ε","epsilon":"ε","epsiv":"ϵ","eqcirc":"≖","eqcolon":"≕","eqsim":"≂","eqslantgtr":"⪖","eqslantless":"⪕","Equal":"⩵","equals":"=","EqualTilde":"≂","equest":"≟","Equilibrium":"⇌","equiv":"≡","equivDD":"⩸","eqvparsl":"⧥","erarr":"⥱","erDot":"≓","escr":"ℯ","Escr":"ℰ","esdot":"≐","Esim":"⩳","esim":"≂","Eta":"Η","eta":"η","ETH":"Ð","eth":"ð","Euml":"Ë","euml":"ë","euro":"€","excl":"!","exist":"∃","Exists":"∃","expectation":"ℰ","exponentiale":"ⅇ","ExponentialE":"ⅇ","fallingdotseq":"≒","Fcy":"Ф","fcy":"ф","female":"♀","ffilig":"ﬃ","fflig":"ﬀ","ffllig":"ﬄ","Ffr":"𝔉","ffr":"𝔣","filig":"ﬁ","FilledSmallSquare":"◼","FilledVerySmallSquare":"▪","fjlig":"fj","flat":"♭","fllig":"ﬂ","fltns":"▱","fnof":"ƒ","Fopf":"𝔽","fopf":"𝕗","forall":"∀","ForAll":"∀","fork":"⋔","forkv":"⫙","Fouriertrf":"ℱ","fpartint":"⨍","frac12":"½","frac13":"⅓","frac14":"¼","frac15":"⅕","frac16":"⅙","frac18":"⅛","frac23":"⅔","frac25":"⅖","frac34":"¾","frac35":"⅗","frac38":"⅜","frac45":"⅘","frac56":"⅚","frac58":"⅝","frac78":"⅞","frasl":"⁄","frown":"⌢","fscr":"𝒻","Fscr":"ℱ","gacute":"ǵ","Gamma":"Γ","gamma":"γ","Gammad":"Ϝ","gammad":"ϝ","gap":"⪆","Gbreve":"Ğ","gbreve":"ğ","Gcedil":"Ģ","Gcirc":"Ĝ","gcirc":"ĝ","Gcy":"Г","gcy":"г","Gdot":"Ġ","gdot":"ġ","ge":"≥","gE":"≧","gEl":"⪌","gel":"⋛","geq":"≥","geqq":"≧","geqslant":"⩾","gescc":"⪩","ges":"⩾","gesdot":"⪀","gesdoto":"⪂","gesdotol":"⪄","gesl":"⋛︀","gesles":"⪔","Gfr":"𝔊","gfr":"𝔤","gg":"≫","Gg":"⋙","ggg":"⋙","gimel":"ℷ","GJcy":"Ѓ","gjcy":"ѓ","gla":"⪥","gl":"≷","glE":"⪒","glj":"⪤","gnap":"⪊","gnapprox":"⪊","gne":"⪈","gnE":"≩","gneq":"⪈","gneqq":"≩","gnsim":"⋧","Gopf":"𝔾","gopf":"𝕘","grave":"`","GreaterEqual":"≥","GreaterEqualLess":"⋛","GreaterFullEqual":"≧","GreaterGreater":"⪢","GreaterLess":"≷","GreaterSlantEqual":"⩾","GreaterTilde":"≳","Gscr":"𝒢","gscr":"ℊ","gsim":"≳","gsime":"⪎","gsiml":"⪐","gtcc":"⪧","gtcir":"⩺","gt":">","GT":">","Gt":"≫","gtdot":"⋗","gtlPar":"⦕","gtquest":"⩼","gtrapprox":"⪆","gtrarr":"⥸","gtrdot":"⋗","gtreqless":"⋛","gtreqqless":"⪌","gtrless":"≷","gtrsim":"≳","gvertneqq":"≩︀","gvnE":"≩︀","Hacek":"ˇ","hairsp":" ","half":"½","hamilt":"ℋ","HARDcy":"Ъ","hardcy":"ъ","harrcir":"⥈","harr":"↔","hArr":"⇔","harrw":"↭","Hat":"^","hbar":"ℏ","Hcirc":"Ĥ","hcirc":"ĥ","hearts":"♥","heartsuit":"♥","hellip":"…","hercon":"⊹","hfr":"𝔥","Hfr":"ℌ","HilbertSpace":"ℋ","hksearow":"⤥","hkswarow":"⤦","hoarr":"⇿","homtht":"∻","hookleftarrow":"↩","hookrightarrow":"↪","hopf":"𝕙","Hopf":"ℍ","horbar":"―","HorizontalLine":"─","hscr":"𝒽","Hscr":"ℋ","hslash":"ℏ","Hstrok":"Ħ","hstrok":"ħ","HumpDownHump":"≎","HumpEqual":"≏","hybull":"⁃","hyphen":"‐","Iacute":"Í","iacute":"í","ic":"⁣","Icirc":"Î","icirc":"î","Icy":"И","icy":"и","Idot":"İ","IEcy":"Е","iecy":"е","iexcl":"¡","iff":"⇔","ifr":"𝔦","Ifr":"ℑ","Igrave":"Ì","igrave":"ì","ii":"ⅈ","iiiint":"⨌","iiint":"∭","iinfin":"⧜","iiota":"℩","IJlig":"Ĳ","ijlig":"ĳ","Imacr":"Ī","imacr":"ī","image":"ℑ","ImaginaryI":"ⅈ","imagline":"ℐ","imagpart":"ℑ","imath":"ı","Im":"ℑ","imof":"⊷","imped":"Ƶ","Implies":"⇒","incare":"℅","in":"∈","infin":"∞","infintie":"⧝","inodot":"ı","intcal":"⊺","int":"∫","Int":"∬","integers":"ℤ","Integral":"∫","intercal":"⊺","Intersection":"⋂","intlarhk":"⨗","intprod":"⨼","InvisibleComma":"⁣","InvisibleTimes":"⁢","IOcy":"Ё","iocy":"ё","Iogon":"Į","iogon":"į","Iopf":"𝕀","iopf":"𝕚","Iota":"Ι","iota":"ι","iprod":"⨼","iquest":"¿","iscr":"𝒾","Iscr":"ℐ","isin":"∈","isindot":"⋵","isinE":"⋹","isins":"⋴","isinsv":"⋳","isinv":"∈","it":"⁢","Itilde":"Ĩ","itilde":"ĩ","Iukcy":"І","iukcy":"і","Iuml":"Ï","iuml":"ï","Jcirc":"Ĵ","jcirc":"ĵ","Jcy":"Й","jcy":"й","Jfr":"𝔍","jfr":"𝔧","jmath":"ȷ","Jopf":"𝕁","jopf":"𝕛","Jscr":"𝒥","jscr":"𝒿","Jsercy":"Ј","jsercy":"ј","Jukcy":"Є","jukcy":"є","Kappa":"Κ","kappa":"κ","kappav":"ϰ","Kcedil":"Ķ","kcedil":"ķ","Kcy":"К","kcy":"к","Kfr":"𝔎","kfr":"𝔨","kgreen":"ĸ","KHcy":"Х","khcy":"х","KJcy":"Ќ","kjcy":"ќ","Kopf":"𝕂","kopf":"𝕜","Kscr":"𝒦","kscr":"𝓀","lAarr":"⇚","Lacute":"Ĺ","lacute":"ĺ","laemptyv":"⦴","lagran":"ℒ","Lambda":"Λ","lambda":"λ","lang":"⟨","Lang":"⟪","langd":"⦑","langle":"⟨","lap":"⪅","Laplacetrf":"ℒ","laquo":"«","larrb":"⇤","larrbfs":"⤟","larr":"←","Larr":"↞","lArr":"⇐","larrfs":"⤝","larrhk":"↩","larrlp":"↫","larrpl":"⤹","larrsim":"⥳","larrtl":"↢","latail":"⤙","lAtail":"⤛","lat":"⪫","late":"⪭","lates":"⪭︀","lbarr":"⤌","lBarr":"⤎","lbbrk":"❲","lbrace":"{","lbrack":"[","lbrke":"⦋","lbrksld":"⦏","lbrkslu":"⦍","Lcaron":"Ľ","lcaron":"ľ","Lcedil":"Ļ","lcedil":"ļ","lceil":"⌈","lcub":"{","Lcy":"Л","lcy":"л","ldca":"⤶","ldquo":"“","ldquor":"„","ldrdhar":"⥧","ldrushar":"⥋","ldsh":"↲","le":"≤","lE":"≦","LeftAngleBracket":"⟨","LeftArrowBar":"⇤","leftarrow":"←","LeftArrow":"←","Leftarrow":"⇐","LeftArrowRightArrow":"⇆","leftarrowtail":"↢","LeftCeiling":"⌈","LeftDoubleBracket":"⟦","LeftDownTeeVector":"⥡","LeftDownVectorBar":"⥙","LeftDownVector":"⇃","LeftFloor":"⌊","leftharpoondown":"↽","leftharpoonup":"↼","leftleftarrows":"⇇","leftrightarrow":"↔","LeftRightArrow":"↔","Leftrightarrow":"⇔","leftrightarrows":"⇆","leftrightharpoons":"⇋","leftrightsquigarrow":"↭","LeftRightVector":"⥎","LeftTeeArrow":"↤","LeftTee":"⊣","LeftTeeVector":"⥚","leftthreetimes":"⋋","LeftTriangleBar":"⧏","LeftTriangle":"⊲","LeftTriangleEqual":"⊴","LeftUpDownVector":"⥑","LeftUpTeeVector":"⥠","LeftUpVectorBar":"⥘","LeftUpVector":"↿","LeftVectorBar":"⥒","LeftVector":"↼","lEg":"⪋","leg":"⋚","leq":"≤","leqq":"≦","leqslant":"⩽","lescc":"⪨","les":"⩽","lesdot":"⩿","lesdoto":"⪁","lesdotor":"⪃","lesg":"⋚︀","lesges":"⪓","lessapprox":"⪅","lessdot":"⋖","lesseqgtr":"⋚","lesseqqgtr":"⪋","LessEqualGreater":"⋚","LessFullEqual":"≦","LessGreater":"≶","lessgtr":"≶","LessLess":"⪡","lesssim":"≲","LessSlantEqual":"⩽","LessTilde":"≲","lfisht":"⥼","lfloor":"⌊","Lfr":"𝔏","lfr":"𝔩","lg":"≶","lgE":"⪑","lHar":"⥢","lhard":"↽","lharu":"↼","lharul":"⥪","lhblk":"▄","LJcy":"Љ","ljcy":"љ","llarr":"⇇","ll":"≪","Ll":"⋘","llcorner":"⌞","Lleftarrow":"⇚","llhard":"⥫","lltri":"◺","Lmidot":"Ŀ","lmidot":"ŀ","lmoustache":"⎰","lmoust":"⎰","lnap":"⪉","lnapprox":"⪉","lne":"⪇","lnE":"≨","lneq":"⪇","lneqq":"≨","lnsim":"⋦","loang":"⟬","loarr":"⇽","lobrk":"⟦","longleftarrow":"⟵","LongLeftArrow":"⟵","Longleftarrow":"⟸","longleftrightarrow":"⟷","LongLeftRightArrow":"⟷","Longleftrightarrow":"⟺","longmapsto":"⟼","longrightarrow":"⟶","LongRightArrow":"⟶","Longrightarrow":"⟹","looparrowleft":"↫","looparrowright":"↬","lopar":"⦅","Lopf":"𝕃","lopf":"𝕝","loplus":"⨭","lotimes":"⨴","lowast":"∗","lowbar":"_","LowerLeftArrow":"↙","LowerRightArrow":"↘","loz":"◊","lozenge":"◊","lozf":"⧫","lpar":"(","lparlt":"⦓","lrarr":"⇆","lrcorner":"⌟","lrhar":"⇋","lrhard":"⥭","lrm":"‎","lrtri":"⊿","lsaquo":"‹","lscr":"𝓁","Lscr":"ℒ","lsh":"↰","Lsh":"↰","lsim":"≲","lsime":"⪍","lsimg":"⪏","lsqb":"[","lsquo":"‘","lsquor":"‚","Lstrok":"Ł","lstrok":"ł","ltcc":"⪦","ltcir":"⩹","lt":"<","LT":"<","Lt":"≪","ltdot":"⋖","lthree":"⋋","ltimes":"⋉","ltlarr":"⥶","ltquest":"⩻","ltri":"◃","ltrie":"⊴","ltrif":"◂","ltrPar":"⦖","lurdshar":"⥊","luruhar":"⥦","lvertneqq":"≨︀","lvnE":"≨︀","macr":"¯","male":"♂","malt":"✠","maltese":"✠","Map":"⤅","map":"↦","mapsto":"↦","mapstodown":"↧","mapstoleft":"↤","mapstoup":"↥","marker":"▮","mcomma":"⨩","Mcy":"М","mcy":"м","mdash":"—","mDDot":"∺","measuredangle":"∡","MediumSpace":" ","Mellintrf":"ℳ","Mfr":"𝔐","mfr":"𝔪","mho":"℧","micro":"µ","midast":"*","midcir":"⫰","mid":"∣","middot":"·","minusb":"⊟","minus":"−","minusd":"∸","minusdu":"⨪","MinusPlus":"∓","mlcp":"⫛","mldr":"…","mnplus":"∓","models":"⊧","Mopf":"𝕄","mopf":"𝕞","mp":"∓","mscr":"𝓂","Mscr":"ℳ","mstpos":"∾","Mu":"Μ","mu":"μ","multimap":"⊸","mumap":"⊸","nabla":"∇","Nacute":"Ń","nacute":"ń","nang":"∠⃒","nap":"≉","napE":"⩰̸","napid":"≋̸","napos":"ŉ","napprox":"≉","natural":"♮","naturals":"ℕ","natur":"♮","nbsp":" ","nbump":"≎̸","nbumpe":"≏̸","ncap":"⩃","Ncaron":"Ň","ncaron":"ň","Ncedil":"Ņ","ncedil":"ņ","ncong":"≇","ncongdot":"⩭̸","ncup":"⩂","Ncy":"Н","ncy":"н","ndash":"–","nearhk":"⤤","nearr":"↗","neArr":"⇗","nearrow":"↗","ne":"≠","nedot":"≐̸","NegativeMediumSpace":"​","NegativeThickSpace":"​","NegativeThinSpace":"​","NegativeVeryThinSpace":"​","nequiv":"≢","nesear":"⤨","nesim":"≂̸","NestedGreaterGreater":"≫","NestedLessLess":"≪","NewLine":"\n","nexist":"∄","nexists":"∄","Nfr":"𝔑","nfr":"𝔫","ngE":"≧̸","nge":"≱","ngeq":"≱","ngeqq":"≧̸","ngeqslant":"⩾̸","nges":"⩾̸","nGg":"⋙̸","ngsim":"≵","nGt":"≫⃒","ngt":"≯","ngtr":"≯","nGtv":"≫̸","nharr":"↮","nhArr":"⇎","nhpar":"⫲","ni":"∋","nis":"⋼","nisd":"⋺","niv":"∋","NJcy":"Њ","njcy":"њ","nlarr":"↚","nlArr":"⇍","nldr":"‥","nlE":"≦̸","nle":"≰","nleftarrow":"↚","nLeftarrow":"⇍","nleftrightarrow":"↮","nLeftrightarrow":"⇎","nleq":"≰","nleqq":"≦̸","nleqslant":"⩽̸","nles":"⩽̸","nless":"≮","nLl":"⋘̸","nlsim":"≴","nLt":"≪⃒","nlt":"≮","nltri":"⋪","nltrie":"⋬","nLtv":"≪̸","nmid":"∤","NoBreak":"⁠","NonBreakingSpace":" ","nopf":"𝕟","Nopf":"ℕ","Not":"⫬","not":"¬","NotCongruent":"≢","NotCupCap":"≭","NotDoubleVerticalBar":"∦","NotElement":"∉","NotEqual":"≠","NotEqualTilde":"≂̸","NotExists":"∄","NotGreater":"≯","NotGreaterEqual":"≱","NotGreaterFullEqual":"≧̸","NotGreaterGreater":"≫̸","NotGreaterLess":"≹","NotGreaterSlantEqual":"⩾̸","NotGreaterTilde":"≵","NotHumpDownHump":"≎̸","NotHumpEqual":"≏̸","notin":"∉","notindot":"⋵̸","notinE":"⋹̸","notinva":"∉","notinvb":"⋷","notinvc":"⋶","NotLeftTriangleBar":"⧏̸","NotLeftTriangle":"⋪","NotLeftTriangleEqual":"⋬","NotLess":"≮","NotLessEqual":"≰","NotLessGreater":"≸","NotLessLess":"≪̸","NotLessSlantEqual":"⩽̸","NotLessTilde":"≴","NotNestedGreaterGreater":"⪢̸","NotNestedLessLess":"⪡̸","notni":"∌","notniva":"∌","notnivb":"⋾","notnivc":"⋽","NotPrecedes":"⊀","NotPrecedesEqual":"⪯̸","NotPrecedesSlantEqual":"⋠","NotReverseElement":"∌","NotRightTriangleBar":"⧐̸","NotRightTriangle":"⋫","NotRightTriangleEqual":"⋭","NotSquareSubset":"⊏̸","NotSquareSubsetEqual":"⋢","NotSquareSuperset":"⊐̸","NotSquareSupersetEqual":"⋣","NotSubset":"⊂⃒","NotSubsetEqual":"⊈","NotSucceeds":"⊁","NotSucceedsEqual":"⪰̸","NotSucceedsSlantEqual":"⋡","NotSucceedsTilde":"≿̸","NotSuperset":"⊃⃒","NotSupersetEqual":"⊉","NotTilde":"≁","NotTildeEqual":"≄","NotTildeFullEqual":"≇","NotTildeTilde":"≉","NotVerticalBar":"∤","nparallel":"∦","npar":"∦","nparsl":"⫽⃥","npart":"∂̸","npolint":"⨔","npr":"⊀","nprcue":"⋠","nprec":"⊀","npreceq":"⪯̸","npre":"⪯̸","nrarrc":"⤳̸","nrarr":"↛","nrArr":"⇏","nrarrw":"↝̸","nrightarrow":"↛","nRightarrow":"⇏","nrtri":"⋫","nrtrie":"⋭","nsc":"⊁","nsccue":"⋡","nsce":"⪰̸","Nscr":"𝒩","nscr":"𝓃","nshortmid":"∤","nshortparallel":"∦","nsim":"≁","nsime":"≄","nsimeq":"≄","nsmid":"∤","nspar":"∦","nsqsube":"⋢","nsqsupe":"⋣","nsub":"⊄","nsubE":"⫅̸","nsube":"⊈","nsubset":"⊂⃒","nsubseteq":"⊈","nsubseteqq":"⫅̸","nsucc":"⊁","nsucceq":"⪰̸","nsup":"⊅","nsupE":"⫆̸","nsupe":"⊉","nsupset":"⊃⃒","nsupseteq":"⊉","nsupseteqq":"⫆̸","ntgl":"≹","Ntilde":"Ñ","ntilde":"ñ","ntlg":"≸","ntriangleleft":"⋪","ntrianglelefteq":"⋬","ntriangleright":"⋫","ntrianglerighteq":"⋭","Nu":"Ν","nu":"ν","num":"#","numero":"№","numsp":" ","nvap":"≍⃒","nvdash":"⊬","nvDash":"⊭","nVdash":"⊮","nVDash":"⊯","nvge":"≥⃒","nvgt":">⃒","nvHarr":"⤄","nvinfin":"⧞","nvlArr":"⤂","nvle":"≤⃒","nvlt":"<⃒","nvltrie":"⊴⃒","nvrArr":"⤃","nvrtrie":"⊵⃒","nvsim":"∼⃒","nwarhk":"⤣","nwarr":"↖","nwArr":"⇖","nwarrow":"↖","nwnear":"⤧","Oacute":"Ó","oacute":"ó","oast":"⊛","Ocirc":"Ô","ocirc":"ô","ocir":"⊚","Ocy":"О","ocy":"о","odash":"⊝","Odblac":"Ő","odblac":"ő","odiv":"⨸","odot":"⊙","odsold":"⦼","OElig":"Œ","oelig":"œ","ofcir":"⦿","Ofr":"𝔒","ofr":"𝔬","ogon":"˛","Ograve":"Ò","ograve":"ò","ogt":"⧁","ohbar":"⦵","ohm":"Ω","oint":"∮","olarr":"↺","olcir":"⦾","olcross":"⦻","oline":"‾","olt":"⧀","Omacr":"Ō","omacr":"ō","Omega":"Ω","omega":"ω","Omicron":"Ο","omicron":"ο","omid":"⦶","ominus":"⊖","Oopf":"𝕆","oopf":"𝕠","opar":"⦷","OpenCurlyDoubleQuote":"“","OpenCurlyQuote":"‘","operp":"⦹","oplus":"⊕","orarr":"↻","Or":"⩔","or":"∨","ord":"⩝","order":"ℴ","orderof":"ℴ","ordf":"ª","ordm":"º","origof":"⊶","oror":"⩖","orslope":"⩗","orv":"⩛","oS":"Ⓢ","Oscr":"𝒪","oscr":"ℴ","Oslash":"Ø","oslash":"ø","osol":"⊘","Otilde":"Õ","otilde":"õ","otimesas":"⨶","Otimes":"⨷","otimes":"⊗","Ouml":"Ö","ouml":"ö","ovbar":"⌽","OverBar":"‾","OverBrace":"⏞","OverBracket":"⎴","OverParenthesis":"⏜","para":"¶","parallel":"∥","par":"∥","parsim":"⫳","parsl":"⫽","part":"∂","PartialD":"∂","Pcy":"П","pcy":"п","percnt":"%","period":".","permil":"‰","perp":"⊥","pertenk":"‱","Pfr":"𝔓","pfr":"𝔭","Phi":"Φ","phi":"φ","phiv":"ϕ","phmmat":"ℳ","phone":"☎","Pi":"Π","pi":"π","pitchfork":"⋔","piv":"ϖ","planck":"ℏ","planckh":"ℎ","plankv":"ℏ","plusacir":"⨣","plusb":"⊞","pluscir":"⨢","plus":"+","plusdo":"∔","plusdu":"⨥","pluse":"⩲","PlusMinus":"±","plusmn":"±","plussim":"⨦","plustwo":"⨧","pm":"±","Poincareplane":"ℌ","pointint":"⨕","popf":"𝕡","Popf":"ℙ","pound":"£","prap":"⪷","Pr":"⪻","pr":"≺","prcue":"≼","precapprox":"⪷","prec":"≺","preccurlyeq":"≼","Precedes":"≺","PrecedesEqual":"⪯","PrecedesSlantEqual":"≼","PrecedesTilde":"≾","preceq":"⪯","precnapprox":"⪹","precneqq":"⪵","precnsim":"⋨","pre":"⪯","prE":"⪳","precsim":"≾","prime":"′","Prime":"″","primes":"ℙ","prnap":"⪹","prnE":"⪵","prnsim":"⋨","prod":"∏","Product":"∏","profalar":"⌮","profline":"⌒","profsurf":"⌓","prop":"∝","Proportional":"∝","Proportion":"∷","propto":"∝","prsim":"≾","prurel":"⊰","Pscr":"𝒫","pscr":"𝓅","Psi":"Ψ","psi":"ψ","puncsp":" ","Qfr":"𝔔","qfr":"𝔮","qint":"⨌","qopf":"𝕢","Qopf":"ℚ","qprime":"⁗","Qscr":"𝒬","qscr":"𝓆","quaternions":"ℍ","quatint":"⨖","quest":"?","questeq":"≟","quot":"\"","QUOT":"\"","rAarr":"⇛","race":"∽̱","Racute":"Ŕ","racute":"ŕ","radic":"√","raemptyv":"⦳","rang":"⟩","Rang":"⟫","rangd":"⦒","range":"⦥","rangle":"⟩","raquo":"»","rarrap":"⥵","rarrb":"⇥","rarrbfs":"⤠","rarrc":"⤳","rarr":"→","Rarr":"↠","rArr":"⇒","rarrfs":"⤞","rarrhk":"↪","rarrlp":"↬","rarrpl":"⥅","rarrsim":"⥴","Rarrtl":"⤖","rarrtl":"↣","rarrw":"↝","ratail":"⤚","rAtail":"⤜","ratio":"∶","rationals":"ℚ","rbarr":"⤍","rBarr":"⤏","RBarr":"⤐","rbbrk":"❳","rbrace":"}","rbrack":"]","rbrke":"⦌","rbrksld":"⦎","rbrkslu":"⦐","Rcaron":"Ř","rcaron":"ř","Rcedil":"Ŗ","rcedil":"ŗ","rceil":"⌉","rcub":"}","Rcy":"Р","rcy":"р","rdca":"⤷","rdldhar":"⥩","rdquo":"”","rdquor":"”","rdsh":"↳","real":"ℜ","realine":"ℛ","realpart":"ℜ","reals":"ℝ","Re":"ℜ","rect":"▭","reg":"®","REG":"®","ReverseElement":"∋","ReverseEquilibrium":"⇋","ReverseUpEquilibrium":"⥯","rfisht":"⥽","rfloor":"⌋","rfr":"𝔯","Rfr":"ℜ","rHar":"⥤","rhard":"⇁","rharu":"⇀","rharul":"⥬","Rho":"Ρ","rho":"ρ","rhov":"ϱ","RightAngleBracket":"⟩","RightArrowBar":"⇥","rightarrow":"→","RightArrow":"→","Rightarrow":"⇒","RightArrowLeftArrow":"⇄","rightarrowtail":"↣","RightCeiling":"⌉","RightDoubleBracket":"⟧","RightDownTeeVector":"⥝","RightDownVectorBar":"⥕","RightDownVector":"⇂","RightFloor":"⌋","rightharpoondown":"⇁","rightharpoonup":"⇀","rightleftarrows":"⇄","rightleftharpoons":"⇌","rightrightarrows":"⇉","rightsquigarrow":"↝","RightTeeArrow":"↦","RightTee":"⊢","RightTeeVector":"⥛","rightthreetimes":"⋌","RightTriangleBar":"⧐","RightTriangle":"⊳","RightTriangleEqual":"⊵","RightUpDownVector":"⥏","RightUpTeeVector":"⥜","RightUpVectorBar":"⥔","RightUpVector":"↾","RightVectorBar":"⥓","RightVector":"⇀","ring":"˚","risingdotseq":"≓","rlarr":"⇄","rlhar":"⇌","rlm":"‏","rmoustache":"⎱","rmoust":"⎱","rnmid":"⫮","roang":"⟭","roarr":"⇾","robrk":"⟧","ropar":"⦆","ropf":"𝕣","Ropf":"ℝ","roplus":"⨮","rotimes":"⨵","RoundImplies":"⥰","rpar":")","rpargt":"⦔","rppolint":"⨒","rrarr":"⇉","Rrightarrow":"⇛","rsaquo":"›","rscr":"𝓇","Rscr":"ℛ","rsh":"↱","Rsh":"↱","rsqb":"]","rsquo":"’","rsquor":"’","rthree":"⋌","rtimes":"⋊","rtri":"▹","rtrie":"⊵","rtrif":"▸","rtriltri":"⧎","RuleDelayed":"⧴","ruluhar":"⥨","rx":"℞","Sacute":"Ś","sacute":"ś","sbquo":"‚","scap":"⪸","Scaron":"Š","scaron":"š","Sc":"⪼","sc":"≻","sccue":"≽","sce":"⪰","scE":"⪴","Scedil":"Ş","scedil":"ş","Scirc":"Ŝ","scirc":"ŝ","scnap":"⪺","scnE":"⪶","scnsim":"⋩","scpolint":"⨓","scsim":"≿","Scy":"С","scy":"с","sdotb":"⊡","sdot":"⋅","sdote":"⩦","searhk":"⤥","searr":"↘","seArr":"⇘","searrow":"↘","sect":"§","semi":";","seswar":"⤩","setminus":"∖","setmn":"∖","sext":"✶","Sfr":"𝔖","sfr":"𝔰","sfrown":"⌢","sharp":"♯","SHCHcy":"Щ","shchcy":"щ","SHcy":"Ш","shcy":"ш","ShortDownArrow":"↓","ShortLeftArrow":"←","shortmid":"∣","shortparallel":"∥","ShortRightArrow":"→","ShortUpArrow":"↑","shy":"­","Sigma":"Σ","sigma":"σ","sigmaf":"ς","sigmav":"ς","sim":"∼","simdot":"⩪","sime":"≃","simeq":"≃","simg":"⪞","simgE":"⪠","siml":"⪝","simlE":"⪟","simne":"≆","simplus":"⨤","simrarr":"⥲","slarr":"←","SmallCircle":"∘","smallsetminus":"∖","smashp":"⨳","smeparsl":"⧤","smid":"∣","smile":"⌣","smt":"⪪","smte":"⪬","smtes":"⪬︀","SOFTcy":"Ь","softcy":"ь","solbar":"⌿","solb":"⧄","sol":"/","Sopf":"𝕊","sopf":"𝕤","spades":"♠","spadesuit":"♠","spar":"∥","sqcap":"⊓","sqcaps":"⊓︀","sqcup":"⊔","sqcups":"⊔︀","Sqrt":"√","sqsub":"⊏","sqsube":"⊑","sqsubset":"⊏","sqsubseteq":"⊑","sqsup":"⊐","sqsupe":"⊒","sqsupset":"⊐","sqsupseteq":"⊒","square":"□","Square":"□","SquareIntersection":"⊓","SquareSubset":"⊏","SquareSubsetEqual":"⊑","SquareSuperset":"⊐","SquareSupersetEqual":"⊒","SquareUnion":"⊔","squarf":"▪","squ":"□","squf":"▪","srarr":"→","Sscr":"𝒮","sscr":"𝓈","ssetmn":"∖","ssmile":"⌣","sstarf":"⋆","Star":"⋆","star":"☆","starf":"★","straightepsilon":"ϵ","straightphi":"ϕ","strns":"¯","sub":"⊂","Sub":"⋐","subdot":"⪽","subE":"⫅","sube":"⊆","subedot":"⫃","submult":"⫁","subnE":"⫋","subne":"⊊","subplus":"⪿","subrarr":"⥹","subset":"⊂","Subset":"⋐","subseteq":"⊆","subseteqq":"⫅","SubsetEqual":"⊆","subsetneq":"⊊","subsetneqq":"⫋","subsim":"⫇","subsub":"⫕","subsup":"⫓","succapprox":"⪸","succ":"≻","succcurlyeq":"≽","Succeeds":"≻","SucceedsEqual":"⪰","SucceedsSlantEqual":"≽","SucceedsTilde":"≿","succeq":"⪰","succnapprox":"⪺","succneqq":"⪶","succnsim":"⋩","succsim":"≿","SuchThat":"∋","sum":"∑","Sum":"∑","sung":"♪","sup1":"¹","sup2":"²","sup3":"³","sup":"⊃","Sup":"⋑","supdot":"⪾","supdsub":"⫘","supE":"⫆","supe":"⊇","supedot":"⫄","Superset":"⊃","SupersetEqual":"⊇","suphsol":"⟉","suphsub":"⫗","suplarr":"⥻","supmult":"⫂","supnE":"⫌","supne":"⊋","supplus":"⫀","supset":"⊃","Supset":"⋑","supseteq":"⊇","supseteqq":"⫆","supsetneq":"⊋","supsetneqq":"⫌","supsim":"⫈","supsub":"⫔","supsup":"⫖","swarhk":"⤦","swarr":"↙","swArr":"⇙","swarrow":"↙","swnwar":"⤪","szlig":"ß","Tab":"\t","target":"⌖","Tau":"Τ","tau":"τ","tbrk":"⎴","Tcaron":"Ť","tcaron":"ť","Tcedil":"Ţ","tcedil":"ţ","Tcy":"Т","tcy":"т","tdot":"⃛","telrec":"⌕","Tfr":"𝔗","tfr":"𝔱","there4":"∴","therefore":"∴","Therefore":"∴","Theta":"Θ","theta":"θ","thetasym":"ϑ","thetav":"ϑ","thickapprox":"≈","thicksim":"∼","ThickSpace":"  ","ThinSpace":" ","thinsp":" ","thkap":"≈","thksim":"∼","THORN":"Þ","thorn":"þ","tilde":"˜","Tilde":"∼","TildeEqual":"≃","TildeFullEqual":"≅","TildeTilde":"≈","timesbar":"⨱","timesb":"⊠","times":"×","timesd":"⨰","tint":"∭","toea":"⤨","topbot":"⌶","topcir":"⫱","top":"⊤","Topf":"𝕋","topf":"𝕥","topfork":"⫚","tosa":"⤩","tprime":"‴","trade":"™","TRADE":"™","triangle":"▵","triangledown":"▿","triangleleft":"◃","trianglelefteq":"⊴","triangleq":"≜","triangleright":"▹","trianglerighteq":"⊵","tridot":"◬","trie":"≜","triminus":"⨺","TripleDot":"⃛","triplus":"⨹","trisb":"⧍","tritime":"⨻","trpezium":"⏢","Tscr":"𝒯","tscr":"𝓉","TScy":"Ц","tscy":"ц","TSHcy":"Ћ","tshcy":"ћ","Tstrok":"Ŧ","tstrok":"ŧ","twixt":"≬","twoheadleftarrow":"↞","twoheadrightarrow":"↠","Uacute":"Ú","uacute":"ú","uarr":"↑","Uarr":"↟","uArr":"⇑","Uarrocir":"⥉","Ubrcy":"Ў","ubrcy":"ў","Ubreve":"Ŭ","ubreve":"ŭ","Ucirc":"Û","ucirc":"û","Ucy":"У","ucy":"у","udarr":"⇅","Udblac":"Ű","udblac":"ű","udhar":"⥮","ufisht":"⥾","Ufr":"𝔘","ufr":"𝔲","Ugrave":"Ù","ugrave":"ù","uHar":"⥣","uharl":"↿","uharr":"↾","uhblk":"▀","ulcorn":"⌜","ulcorner":"⌜","ulcrop":"⌏","ultri":"◸","Umacr":"Ū","umacr":"ū","uml":"¨","UnderBar":"_","UnderBrace":"⏟","UnderBracket":"⎵","UnderParenthesis":"⏝","Union":"⋃","UnionPlus":"⊎","Uogon":"Ų","uogon":"ų","Uopf":"𝕌","uopf":"𝕦","UpArrowBar":"⤒","uparrow":"↑","UpArrow":"↑","Uparrow":"⇑","UpArrowDownArrow":"⇅","updownarrow":"↕","UpDownArrow":"↕","Updownarrow":"⇕","UpEquilibrium":"⥮","upharpoonleft":"↿","upharpoonright":"↾","uplus":"⊎","UpperLeftArrow":"↖","UpperRightArrow":"↗","upsi":"υ","Upsi":"ϒ","upsih":"ϒ","Upsilon":"Υ","upsilon":"υ","UpTeeArrow":"↥","UpTee":"⊥","upuparrows":"⇈","urcorn":"⌝","urcorner":"⌝","urcrop":"⌎","Uring":"Ů","uring":"ů","urtri":"◹","Uscr":"𝒰","uscr":"𝓊","utdot":"⋰","Utilde":"Ũ","utilde":"ũ","utri":"▵","utrif":"▴","uuarr":"⇈","Uuml":"Ü","uuml":"ü","uwangle":"⦧","vangrt":"⦜","varepsilon":"ϵ","varkappa":"ϰ","varnothing":"∅","varphi":"ϕ","varpi":"ϖ","varpropto":"∝","varr":"↕","vArr":"⇕","varrho":"ϱ","varsigma":"ς","varsubsetneq":"⊊︀","varsubsetneqq":"⫋︀","varsupsetneq":"⊋︀","varsupsetneqq":"⫌︀","vartheta":"ϑ","vartriangleleft":"⊲","vartriangleright":"⊳","vBar":"⫨","Vbar":"⫫","vBarv":"⫩","Vcy":"В","vcy":"в","vdash":"⊢","vDash":"⊨","Vdash":"⊩","VDash":"⊫","Vdashl":"⫦","veebar":"⊻","vee":"∨","Vee":"⋁","veeeq":"≚","vellip":"⋮","verbar":"|","Verbar":"‖","vert":"|","Vert":"‖","VerticalBar":"∣","VerticalLine":"|","VerticalSeparator":"❘","VerticalTilde":"≀","VeryThinSpace":" ","Vfr":"𝔙","vfr":"𝔳","vltri":"⊲","vnsub":"⊂⃒","vnsup":"⊃⃒","Vopf":"𝕍","vopf":"𝕧","vprop":"∝","vrtri":"⊳","Vscr":"𝒱","vscr":"𝓋","vsubnE":"⫋︀","vsubne":"⊊︀","vsupnE":"⫌︀","vsupne":"⊋︀","Vvdash":"⊪","vzigzag":"⦚","Wcirc":"Ŵ","wcirc":"ŵ","wedbar":"⩟","wedge":"∧","Wedge":"⋀","wedgeq":"≙","weierp":"℘","Wfr":"𝔚","wfr":"𝔴","Wopf":"𝕎","wopf":"𝕨","wp":"℘","wr":"≀","wreath":"≀","Wscr":"𝒲","wscr":"𝓌","xcap":"⋂","xcirc":"◯","xcup":"⋃","xdtri":"▽","Xfr":"𝔛","xfr":"𝔵","xharr":"⟷","xhArr":"⟺","Xi":"Ξ","xi":"ξ","xlarr":"⟵","xlArr":"⟸","xmap":"⟼","xnis":"⋻","xodot":"⨀","Xopf":"𝕏","xopf":"𝕩","xoplus":"⨁","xotime":"⨂","xrarr":"⟶","xrArr":"⟹","Xscr":"𝒳","xscr":"𝓍","xsqcup":"⨆","xuplus":"⨄","xutri":"△","xvee":"⋁","xwedge":"⋀","Yacute":"Ý","yacute":"ý","YAcy":"Я","yacy":"я","Ycirc":"Ŷ","ycirc":"ŷ","Ycy":"Ы","ycy":"ы","yen":"¥","Yfr":"𝔜","yfr":"𝔶","YIcy":"Ї","yicy":"ї","Yopf":"𝕐","yopf":"𝕪","Yscr":"𝒴","yscr":"𝓎","YUcy":"Ю","yucy":"ю","yuml":"ÿ","Yuml":"Ÿ","Zacute":"Ź","zacute":"ź","Zcaron":"Ž","zcaron":"ž","Zcy":"З","zcy":"з","Zdot":"Ż","zdot":"ż","zeetrf":"ℨ","ZeroWidthSpace":"​","Zeta":"Ζ","zeta":"ζ","zfr":"𝔷","Zfr":"ℨ","ZHcy":"Ж","zhcy":"ж","zigrarr":"⇝","zopf":"𝕫","Zopf":"ℤ","Zscr":"𝒵","zscr":"𝓏","zwj":"‍","zwnj":"‌"}

/***/ }),
/* 160 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 161 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 162 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 163 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 164 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 165 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 166 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 167 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 168 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 169 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 170 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 171 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 172 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 173 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 174 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */
/***/ (function(module, exports) {

module.exports = {"100":"💯","1234":"🔢","grinning":"😀","smiley":"😃","smile":"😄","grin":"😁","laughing":"😆","satisfied":"😆","sweat_smile":"😅","joy":"😂","rofl":"🤣","relaxed":"☺️","blush":"😊","innocent":"😇","slightly_smiling_face":"🙂","upside_down_face":"🙃","wink":"😉","relieved":"😌","heart_eyes":"😍","kissing_heart":"😘","kissing":"😗","kissing_smiling_eyes":"😙","kissing_closed_eyes":"😚","yum":"😋","stuck_out_tongue_winking_eye":"😜","stuck_out_tongue_closed_eyes":"😝","stuck_out_tongue":"😛","money_mouth_face":"🤑","hugs":"🤗","nerd_face":"🤓","sunglasses":"😎","clown_face":"🤡","cowboy_hat_face":"🤠","smirk":"😏","unamused":"😒","disappointed":"😞","pensive":"😔","worried":"😟","confused":"😕","slightly_frowning_face":"🙁","frowning_face":"☹️","persevere":"😣","confounded":"😖","tired_face":"😫","weary":"😩","triumph":"😤","angry":"😠","rage":"😡","pout":"😡","no_mouth":"😶","neutral_face":"😐","expressionless":"😑","hushed":"😯","frowning":"😦","anguished":"😧","open_mouth":"😮","astonished":"😲","dizzy_face":"😵","flushed":"😳","scream":"😱","fearful":"😨","cold_sweat":"😰","cry":"😢","disappointed_relieved":"😥","drooling_face":"🤤","sob":"😭","sweat":"😓","sleepy":"😪","sleeping":"😴","roll_eyes":"🙄","thinking":"🤔","lying_face":"🤥","grimacing":"😬","zipper_mouth_face":"🤐","nauseated_face":"🤢","sneezing_face":"🤧","mask":"😷","face_with_thermometer":"🤒","face_with_head_bandage":"🤕","smiling_imp":"😈","imp":"👿","japanese_ogre":"👹","japanese_goblin":"👺","hankey":"💩","poop":"💩","shit":"💩","ghost":"👻","skull":"💀","skull_and_crossbones":"☠️","alien":"👽","space_invader":"👾","robot":"🤖","jack_o_lantern":"🎃","smiley_cat":"😺","smile_cat":"😸","joy_cat":"😹","heart_eyes_cat":"😻","smirk_cat":"😼","kissing_cat":"😽","scream_cat":"🙀","crying_cat_face":"😿","pouting_cat":"😾","open_hands":"👐","raised_hands":"🙌","clap":"👏","pray":"🙏","handshake":"🤝","+1":"👍","thumbsup":"👍","-1":"👎","thumbsdown":"👎","fist_oncoming":"👊","facepunch":"👊","punch":"👊","fist_raised":"✊","fist":"✊","fist_left":"🤛","fist_right":"🤜","crossed_fingers":"🤞","v":"✌️","metal":"🤘","ok_hand":"👌","point_left":"👈","point_right":"👉","point_up_2":"👆","point_down":"👇","point_up":"☝️","hand":"✋","raised_hand":"✋","raised_back_of_hand":"🤚","raised_hand_with_fingers_splayed":"🖐","vulcan_salute":"🖖","wave":"👋","call_me_hand":"🤙","muscle":"💪","middle_finger":"🖕","fu":"🖕","writing_hand":"✍️","selfie":"🤳","nail_care":"💅","ring":"💍","lipstick":"💄","kiss":"💋","lips":"👄","tongue":"👅","ear":"👂","nose":"👃","footprints":"👣","eye":"👁","eyes":"👀","speaking_head":"🗣","bust_in_silhouette":"👤","busts_in_silhouette":"👥","baby":"👶","boy":"👦","girl":"👧","man":"👨","woman":"👩","blonde_woman":"👱‍♀","blonde_man":"👱","person_with_blond_hair":"👱","older_man":"👴","older_woman":"👵","man_with_gua_pi_mao":"👲","woman_with_turban":"👳‍♀","man_with_turban":"👳","policewoman":"👮‍♀","policeman":"👮","cop":"👮","construction_worker_woman":"👷‍♀","construction_worker_man":"👷","construction_worker":"👷","guardswoman":"💂‍♀","guardsman":"💂","female_detective":"🕵️‍♀️","male_detective":"🕵","detective":"🕵","woman_health_worker":"👩‍⚕","man_health_worker":"👨‍⚕","woman_farmer":"👩‍🌾","man_farmer":"👨‍🌾","woman_cook":"👩‍🍳","man_cook":"👨‍🍳","woman_student":"👩‍🎓","man_student":"👨‍🎓","woman_singer":"👩‍🎤","man_singer":"👨‍🎤","woman_teacher":"👩‍🏫","man_teacher":"👨‍🏫","woman_factory_worker":"👩‍🏭","man_factory_worker":"👨‍🏭","woman_technologist":"👩‍💻","man_technologist":"👨‍💻","woman_office_worker":"👩‍💼","man_office_worker":"👨‍💼","woman_mechanic":"👩‍🔧","man_mechanic":"👨‍🔧","woman_scientist":"👩‍🔬","man_scientist":"👨‍🔬","woman_artist":"👩‍🎨","man_artist":"👨‍🎨","woman_firefighter":"👩‍🚒","man_firefighter":"👨‍🚒","woman_pilot":"👩‍✈","man_pilot":"👨‍✈","woman_astronaut":"👩‍🚀","man_astronaut":"👨‍🚀","woman_judge":"👩‍⚖","man_judge":"👨‍⚖","mrs_claus":"🤶","santa":"🎅","princess":"👸","prince":"🤴","bride_with_veil":"👰","man_in_tuxedo":"🤵","angel":"👼","pregnant_woman":"🤰","bowing_woman":"🙇‍♀","bowing_man":"🙇","bow":"🙇","tipping_hand_woman":"💁","information_desk_person":"💁","sassy_woman":"💁","tipping_hand_man":"💁‍♂","sassy_man":"💁‍♂","no_good_woman":"🙅","no_good":"🙅","ng_woman":"🙅","no_good_man":"🙅‍♂","ng_man":"🙅‍♂","ok_woman":"🙆","ok_man":"🙆‍♂","raising_hand_woman":"🙋","raising_hand":"🙋","raising_hand_man":"🙋‍♂","woman_facepalming":"🤦‍♀","man_facepalming":"🤦‍♂","woman_shrugging":"🤷‍♀","man_shrugging":"🤷‍♂","pouting_woman":"🙎","person_with_pouting_face":"🙎","pouting_man":"🙎‍♂","frowning_woman":"🙍","person_frowning":"🙍","frowning_man":"🙍‍♂","haircut_woman":"💇","haircut":"💇","haircut_man":"💇‍♂","massage_woman":"💆","massage":"💆","massage_man":"💆‍♂","business_suit_levitating":"🕴","dancer":"💃","man_dancing":"🕺","dancing_women":"👯","dancers":"👯","dancing_men":"👯‍♂","walking_woman":"🚶‍♀","walking_man":"🚶","walking":"🚶","running_woman":"🏃‍♀","running_man":"🏃","runner":"🏃","running":"🏃","couple":"👫","two_women_holding_hands":"👭","two_men_holding_hands":"👬","couple_with_heart_woman_man":"💑","couple_with_heart":"💑","couple_with_heart_woman_woman":"👩‍❤️‍👩","couple_with_heart_man_man":"👨‍❤️‍👨","couplekiss_man_woman":"💏","couplekiss_woman_woman":"👩‍❤️‍💋‍👩","couplekiss_man_man":"👨‍❤️‍💋‍👨","family_man_woman_boy":"👪","family":"👪","family_man_woman_girl":"👨‍👩‍👧","family_man_woman_girl_boy":"👨‍👩‍👧‍👦","family_man_woman_boy_boy":"👨‍👩‍👦‍👦","family_man_woman_girl_girl":"👨‍👩‍👧‍👧","family_woman_woman_boy":"👩‍👩‍👦","family_woman_woman_girl":"👩‍👩‍👧","family_woman_woman_girl_boy":"👩‍👩‍👧‍👦","family_woman_woman_boy_boy":"👩‍👩‍👦‍👦","family_woman_woman_girl_girl":"👩‍👩‍👧‍👧","family_man_man_boy":"👨‍👨‍👦","family_man_man_girl":"👨‍👨‍👧","family_man_man_girl_boy":"👨‍👨‍👧‍👦","family_man_man_boy_boy":"👨‍👨‍👦‍👦","family_man_man_girl_girl":"👨‍👨‍👧‍👧","family_woman_boy":"👩‍👦","family_woman_girl":"👩‍👧","family_woman_girl_boy":"👩‍👧‍👦","family_woman_boy_boy":"👩‍👦‍👦","family_woman_girl_girl":"👩‍👧‍👧","family_man_boy":"👨‍👦","family_man_girl":"👨‍👧","family_man_girl_boy":"👨‍👧‍👦","family_man_boy_boy":"👨‍👦‍👦","family_man_girl_girl":"👨‍👧‍👧","womans_clothes":"👚","shirt":"👕","tshirt":"👕","jeans":"👖","necktie":"👔","dress":"👗","bikini":"👙","kimono":"👘","high_heel":"👠","sandal":"👡","boot":"👢","mans_shoe":"👞","shoe":"👞","athletic_shoe":"👟","womans_hat":"👒","tophat":"🎩","mortar_board":"🎓","crown":"👑","rescue_worker_helmet":"⛑","school_satchel":"🎒","pouch":"👝","purse":"👛","handbag":"👜","briefcase":"💼","eyeglasses":"👓","dark_sunglasses":"🕶","closed_umbrella":"🌂","open_umbrella":"☂️","dog":"🐶","cat":"🐱","mouse":"🐭","hamster":"🐹","rabbit":"🐰","fox_face":"🦊","bear":"🐻","panda_face":"🐼","koala":"🐨","tiger":"🐯","lion":"🦁","cow":"🐮","pig":"🐷","pig_nose":"🐽","frog":"🐸","monkey_face":"🐵","see_no_evil":"🙈","hear_no_evil":"🙉","speak_no_evil":"🙊","monkey":"🐒","chicken":"🐔","penguin":"🐧","bird":"🐦","baby_chick":"🐤","hatching_chick":"🐣","hatched_chick":"🐥","duck":"🦆","eagle":"🦅","owl":"🦉","bat":"🦇","wolf":"🐺","boar":"🐗","horse":"🐴","unicorn":"🦄","bee":"🐝","honeybee":"🐝","bug":"🐛","butterfly":"🦋","snail":"🐌","shell":"🐚","beetle":"🐞","ant":"🐜","spider":"🕷","spider_web":"🕸","turtle":"🐢","snake":"🐍","lizard":"🦎","scorpion":"🦂","crab":"🦀","squid":"🦑","octopus":"🐙","shrimp":"🦐","tropical_fish":"🐠","fish":"🐟","blowfish":"🐡","dolphin":"🐬","flipper":"🐬","shark":"🦈","whale":"🐳","whale2":"🐋","crocodile":"🐊","leopard":"🐆","tiger2":"🐅","water_buffalo":"🐃","ox":"🐂","cow2":"🐄","deer":"🦌","dromedary_camel":"🐪","camel":"🐫","elephant":"🐘","rhinoceros":"🦏","gorilla":"🦍","racehorse":"🐎","pig2":"🐖","goat":"🐐","ram":"🐏","sheep":"🐑","dog2":"🐕","poodle":"🐩","cat2":"🐈","rooster":"🐓","turkey":"🦃","dove":"🕊","rabbit2":"🐇","mouse2":"🐁","rat":"🐀","chipmunk":"🐿","feet":"🐾","paw_prints":"🐾","dragon":"🐉","dragon_face":"🐲","cactus":"🌵","christmas_tree":"🎄","evergreen_tree":"🌲","deciduous_tree":"🌳","palm_tree":"🌴","seedling":"🌱","herb":"🌿","shamrock":"☘️","four_leaf_clover":"🍀","bamboo":"🎍","tanabata_tree":"🎋","leaves":"🍃","fallen_leaf":"🍂","maple_leaf":"🍁","mushroom":"🍄","ear_of_rice":"🌾","bouquet":"💐","tulip":"🌷","rose":"🌹","wilted_flower":"🥀","sunflower":"🌻","blossom":"🌼","cherry_blossom":"🌸","hibiscus":"🌺","earth_americas":"🌎","earth_africa":"🌍","earth_asia":"🌏","full_moon":"🌕","waning_gibbous_moon":"🌖","last_quarter_moon":"🌗","waning_crescent_moon":"🌘","new_moon":"🌑","waxing_crescent_moon":"🌒","first_quarter_moon":"🌓","moon":"🌔","waxing_gibbous_moon":"🌔","new_moon_with_face":"🌚","full_moon_with_face":"🌝","sun_with_face":"🌞","first_quarter_moon_with_face":"🌛","last_quarter_moon_with_face":"🌜","crescent_moon":"🌙","dizzy":"💫","star":"⭐️","star2":"🌟","sparkles":"✨","zap":"⚡️","fire":"🔥","boom":"💥","collision":"💥","comet":"☄","sunny":"☀️","sun_behind_small_cloud":"🌤","partly_sunny":"⛅️","sun_behind_large_cloud":"🌥","sun_behind_rain_cloud":"🌦","rainbow":"🌈","cloud":"☁️","cloud_with_rain":"🌧","cloud_with_lightning_and_rain":"⛈","cloud_with_lightning":"🌩","cloud_with_snow":"🌨","snowman_with_snow":"☃️","snowman":"⛄️","snowflake":"❄️","wind_face":"🌬","dash":"💨","tornado":"🌪","fog":"🌫","ocean":"🌊","droplet":"💧","sweat_drops":"💦","umbrella":"☔️","green_apple":"🍏","apple":"🍎","pear":"🍐","tangerine":"🍊","orange":"🍊","mandarin":"🍊","lemon":"🍋","banana":"🍌","watermelon":"🍉","grapes":"🍇","strawberry":"🍓","melon":"🍈","cherries":"🍒","peach":"🍑","pineapple":"🍍","kiwi_fruit":"🥝","avocado":"🥑","tomato":"🍅","eggplant":"🍆","cucumber":"🥒","carrot":"🥕","corn":"🌽","hot_pepper":"🌶","potato":"🥔","sweet_potato":"🍠","chestnut":"🌰","peanuts":"🥜","honey_pot":"🍯","croissant":"🥐","bread":"🍞","baguette_bread":"🥖","cheese":"🧀","egg":"🥚","fried_egg":"🍳","bacon":"🥓","pancakes":"🥞","fried_shrimp":"🍤","poultry_leg":"🍗","meat_on_bone":"🍖","pizza":"🍕","hotdog":"🌭","hamburger":"🍔","fries":"🍟","stuffed_flatbread":"🥙","taco":"🌮","burrito":"🌯","green_salad":"🥗","shallow_pan_of_food":"🥘","spaghetti":"🍝","ramen":"🍜","stew":"🍲","fish_cake":"🍥","sushi":"🍣","bento":"🍱","curry":"🍛","rice":"🍚","rice_ball":"🍙","rice_cracker":"🍘","oden":"🍢","dango":"🍡","shaved_ice":"🍧","ice_cream":"🍨","icecream":"🍦","cake":"🍰","birthday":"🎂","custard":"🍮","lollipop":"🍭","candy":"🍬","chocolate_bar":"🍫","popcorn":"🍿","doughnut":"🍩","cookie":"🍪","milk_glass":"🥛","baby_bottle":"🍼","coffee":"☕️","tea":"🍵","sake":"🍶","beer":"🍺","beers":"🍻","clinking_glasses":"🥂","wine_glass":"🍷","tumbler_glass":"🥃","cocktail":"🍸","tropical_drink":"🍹","champagne":"🍾","spoon":"🥄","fork_and_knife":"🍴","plate_with_cutlery":"🍽","soccer":"⚽️","basketball":"🏀","football":"🏈","baseball":"⚾️","tennis":"🎾","volleyball":"🏐","rugby_football":"🏉","8ball":"🎱","ping_pong":"🏓","badminton":"🏸","goal_net":"🥅","ice_hockey":"🏒","field_hockey":"🏑","cricket":"🏏","golf":"⛳️","bow_and_arrow":"🏹","fishing_pole_and_fish":"🎣","boxing_glove":"🥊","martial_arts_uniform":"🥋","ice_skate":"⛸","ski":"🎿","skier":"⛷","snowboarder":"🏂","weight_lifting_woman":"🏋️‍♀️","weight_lifting_man":"🏋","person_fencing":"🤺","women_wrestling":"🤼‍♀","men_wrestling":"🤼‍♂","woman_cartwheeling":"🤸‍♀","man_cartwheeling":"🤸‍♂","basketball_woman":"⛹️‍♀️","basketball_man":"⛹","woman_playing_handball":"🤾‍♀","man_playing_handball":"🤾‍♂","golfing_woman":"🏌️‍♀️","golfing_man":"🏌","surfing_woman":"🏄‍♀","surfing_man":"🏄","surfer":"🏄","swimming_woman":"🏊‍♀","swimming_man":"🏊","swimmer":"🏊","woman_playing_water_polo":"🤽‍♀","man_playing_water_polo":"🤽‍♂","rowing_woman":"🚣‍♀","rowing_man":"🚣","rowboat":"🚣","horse_racing":"🏇","biking_woman":"🚴‍♀","biking_man":"🚴","bicyclist":"🚴","mountain_biking_woman":"🚵‍♀","mountain_biking_man":"🚵","mountain_bicyclist":"🚵","running_shirt_with_sash":"🎽","medal_sports":"🏅","medal_military":"🎖","1st_place_medal":"🥇","2nd_place_medal":"🥈","3rd_place_medal":"🥉","trophy":"🏆","rosette":"🏵","reminder_ribbon":"🎗","ticket":"🎫","tickets":"🎟","circus_tent":"🎪","woman_juggling":"🤹‍♀","man_juggling":"🤹‍♂","performing_arts":"🎭","art":"🎨","clapper":"🎬","microphone":"🎤","headphones":"🎧","musical_score":"🎼","musical_keyboard":"🎹","drum":"🥁","saxophone":"🎷","trumpet":"🎺","guitar":"🎸","violin":"🎻","game_die":"🎲","dart":"🎯","bowling":"🎳","video_game":"🎮","slot_machine":"🎰","car":"🚗","red_car":"🚗","taxi":"🚕","blue_car":"🚙","bus":"🚌","trolleybus":"🚎","racing_car":"🏎","police_car":"🚓","ambulance":"🚑","fire_engine":"🚒","minibus":"🚐","truck":"🚚","articulated_lorry":"🚛","tractor":"🚜","kick_scooter":"🛴","bike":"🚲","motor_scooter":"🛵","motorcycle":"🏍","rotating_light":"🚨","oncoming_police_car":"🚔","oncoming_bus":"🚍","oncoming_automobile":"🚘","oncoming_taxi":"🚖","aerial_tramway":"🚡","mountain_cableway":"🚠","suspension_railway":"🚟","railway_car":"🚃","train":"🚋","mountain_railway":"🚞","monorail":"🚝","bullettrain_side":"🚄","bullettrain_front":"🚅","light_rail":"🚈","steam_locomotive":"🚂","train2":"🚆","metro":"🚇","tram":"🚊","station":"🚉","helicopter":"🚁","small_airplane":"🛩","airplane":"✈️","flight_departure":"🛫","flight_arrival":"🛬","rocket":"🚀","artificial_satellite":"🛰","seat":"💺","canoe":"🛶","boat":"⛵️","sailboat":"⛵️","motor_boat":"🛥","speedboat":"🚤","passenger_ship":"🛳","ferry":"⛴","ship":"🚢","anchor":"⚓️","construction":"🚧","fuelpump":"⛽️","busstop":"🚏","vertical_traffic_light":"🚦","traffic_light":"🚥","world_map":"🗺","moyai":"🗿","statue_of_liberty":"🗽","fountain":"⛲️","tokyo_tower":"🗼","european_castle":"🏰","japanese_castle":"🏯","stadium":"🏟","ferris_wheel":"🎡","roller_coaster":"🎢","carousel_horse":"🎠","parasol_on_ground":"⛱","beach_umbrella":"🏖","desert_island":"🏝","mountain":"⛰","mountain_snow":"🏔","mount_fuji":"🗻","volcano":"🌋","desert":"🏜","camping":"🏕","tent":"⛺️","railway_track":"🛤","motorway":"🛣","building_construction":"🏗","factory":"🏭","house":"🏠","house_with_garden":"🏡","houses":"🏘","derelict_house":"🏚","office":"🏢","department_store":"🏬","post_office":"🏣","european_post_office":"🏤","hospital":"🏥","bank":"🏦","hotel":"🏨","convenience_store":"🏪","school":"🏫","love_hotel":"🏩","wedding":"💒","classical_building":"🏛","church":"⛪️","mosque":"🕌","synagogue":"🕍","kaaba":"🕋","shinto_shrine":"⛩","japan":"🗾","rice_scene":"🎑","national_park":"🏞","sunrise":"🌅","sunrise_over_mountains":"🌄","stars":"🌠","sparkler":"🎇","fireworks":"🎆","city_sunrise":"🌇","city_sunset":"🌆","cityscape":"🏙","night_with_stars":"🌃","milky_way":"🌌","bridge_at_night":"🌉","foggy":"🌁","watch":"⌚️","iphone":"📱","calling":"📲","computer":"💻","keyboard":"⌨️","desktop_computer":"🖥","printer":"🖨","computer_mouse":"🖱","trackball":"🖲","joystick":"🕹","clamp":"🗜","minidisc":"💽","floppy_disk":"💾","cd":"💿","dvd":"📀","vhs":"📼","camera":"📷","camera_flash":"📸","video_camera":"📹","movie_camera":"🎥","film_projector":"📽","film_strip":"🎞","telephone_receiver":"📞","phone":"☎️","telephone":"☎️","pager":"📟","fax":"📠","tv":"📺","radio":"📻","studio_microphone":"🎙","level_slider":"🎚","control_knobs":"🎛","stopwatch":"⏱","timer_clock":"⏲","alarm_clock":"⏰","mantelpiece_clock":"🕰","hourglass":"⌛️","hourglass_flowing_sand":"⏳","satellite":"📡","battery":"🔋","electric_plug":"🔌","bulb":"💡","flashlight":"🔦","candle":"🕯","wastebasket":"🗑","oil_drum":"🛢","money_with_wings":"💸","dollar":"💵","yen":"💴","euro":"💶","pound":"💷","moneybag":"💰","credit_card":"💳","gem":"💎","balance_scale":"⚖️","wrench":"🔧","hammer":"🔨","hammer_and_pick":"⚒","hammer_and_wrench":"🛠","pick":"⛏","nut_and_bolt":"🔩","gear":"⚙️","chains":"⛓","gun":"🔫","bomb":"💣","hocho":"🔪","knife":"🔪","dagger":"🗡","crossed_swords":"⚔️","shield":"🛡","smoking":"🚬","coffin":"⚰️","funeral_urn":"⚱️","amphora":"🏺","crystal_ball":"🔮","prayer_beads":"📿","barber":"💈","alembic":"⚗️","telescope":"🔭","microscope":"🔬","hole":"🕳","pill":"💊","syringe":"💉","thermometer":"🌡","toilet":"🚽","potable_water":"🚰","shower":"🚿","bathtub":"🛁","bath":"🛀","bellhop_bell":"🛎","key":"🔑","old_key":"🗝","door":"🚪","couch_and_lamp":"🛋","bed":"🛏","sleeping_bed":"🛌","framed_picture":"🖼","shopping":"🛍","shopping_cart":"🛒","gift":"🎁","balloon":"🎈","flags":"🎏","ribbon":"🎀","confetti_ball":"🎊","tada":"🎉","dolls":"🎎","izakaya_lantern":"🏮","lantern":"🏮","wind_chime":"🎐","email":"✉️","envelope":"✉️","envelope_with_arrow":"📩","incoming_envelope":"📨","e-mail":"📧","love_letter":"💌","inbox_tray":"📥","outbox_tray":"📤","package":"📦","label":"🏷","mailbox_closed":"📪","mailbox":"📫","mailbox_with_mail":"📬","mailbox_with_no_mail":"📭","postbox":"📮","postal_horn":"📯","scroll":"📜","page_with_curl":"📃","page_facing_up":"📄","bookmark_tabs":"📑","bar_chart":"📊","chart_with_upwards_trend":"📈","chart_with_downwards_trend":"📉","spiral_notepad":"🗒","spiral_calendar":"🗓","calendar":"📆","date":"📅","card_index":"📇","card_file_box":"🗃","ballot_box":"🗳","file_cabinet":"🗄","clipboard":"📋","file_folder":"📁","open_file_folder":"📂","card_index_dividers":"🗂","newspaper_roll":"🗞","newspaper":"📰","notebook":"📓","notebook_with_decorative_cover":"📔","ledger":"📒","closed_book":"📕","green_book":"📗","blue_book":"📘","orange_book":"📙","books":"📚","book":"📖","open_book":"📖","bookmark":"🔖","link":"🔗","paperclip":"📎","paperclips":"🖇","triangular_ruler":"📐","straight_ruler":"📏","pushpin":"📌","round_pushpin":"📍","scissors":"✂️","pen":"🖊","fountain_pen":"🖋","black_nib":"✒️","paintbrush":"🖌","crayon":"🖍","memo":"📝","pencil":"📝","pencil2":"✏️","mag":"🔍","mag_right":"🔎","lock_with_ink_pen":"🔏","closed_lock_with_key":"🔐","lock":"🔒","unlock":"🔓","heart":"❤️","yellow_heart":"💛","green_heart":"💚","blue_heart":"💙","purple_heart":"💜","black_heart":"🖤","broken_heart":"💔","heavy_heart_exclamation":"❣️","two_hearts":"💕","revolving_hearts":"💞","heartbeat":"💓","heartpulse":"💗","sparkling_heart":"💖","cupid":"💘","gift_heart":"💝","heart_decoration":"💟","peace_symbol":"☮️","latin_cross":"✝️","star_and_crescent":"☪️","om":"🕉","wheel_of_dharma":"☸️","star_of_david":"✡️","six_pointed_star":"🔯","menorah":"🕎","yin_yang":"☯️","orthodox_cross":"☦️","place_of_worship":"🛐","ophiuchus":"⛎","aries":"♈️","taurus":"♉️","gemini":"♊️","cancer":"♋️","leo":"♌️","virgo":"♍️","libra":"♎️","scorpius":"♏️","sagittarius":"♐️","capricorn":"♑️","aquarius":"♒️","pisces":"♓️","id":"🆔","atom_symbol":"⚛️","accept":"🉑","radioactive":"☢️","biohazard":"☣️","mobile_phone_off":"📴","vibration_mode":"📳","eight_pointed_black_star":"✴️","vs":"🆚","white_flower":"💮","ideograph_advantage":"🉐","secret":"㊙️","congratulations":"㊗️","u6e80":"🈵","a":"🅰️","b":"🅱️","ab":"🆎","cl":"🆑","o2":"🅾️","sos":"🆘","x":"❌","o":"⭕️","stop_sign":"🛑","no_entry":"⛔️","name_badge":"📛","no_entry_sign":"🚫","anger":"💢","hotsprings":"♨️","no_pedestrians":"🚷","do_not_litter":"🚯","no_bicycles":"🚳","non-potable_water":"🚱","underage":"🔞","no_mobile_phones":"📵","no_smoking":"🚭","exclamation":"❗️","heavy_exclamation_mark":"❗️","grey_exclamation":"❕","question":"❓","grey_question":"❔","bangbang":"‼️","interrobang":"⁉️","low_brightness":"🔅","high_brightness":"🔆","part_alternation_mark":"〽️","warning":"⚠️","children_crossing":"🚸","trident":"🔱","fleur_de_lis":"⚜️","beginner":"🔰","recycle":"♻️","white_check_mark":"✅","chart":"💹","sparkle":"❇️","eight_spoked_asterisk":"✳️","negative_squared_cross_mark":"❎","globe_with_meridians":"🌐","diamond_shape_with_a_dot_inside":"💠","m":"Ⓜ️","cyclone":"🌀","zzz":"💤","atm":"🏧","wc":"🚾","wheelchair":"♿️","parking":"🅿️","sa":"🈂️","passport_control":"🛂","customs":"🛃","baggage_claim":"🛄","left_luggage":"🛅","mens":"🚹","womens":"🚺","baby_symbol":"🚼","restroom":"🚻","put_litter_in_its_place":"🚮","cinema":"🎦","signal_strength":"📶","koko":"🈁","symbols":"🔣","information_source":"ℹ️","abc":"🔤","abcd":"🔡","capital_abcd":"🔠","ng":"🆖","ok":"🆗","up":"🆙","cool":"🆒","new":"🆕","free":"🆓","zero":"0️⃣","one":"1️⃣","two":"2️⃣","three":"3️⃣","four":"4️⃣","five":"5️⃣","six":"6️⃣","seven":"7️⃣","eight":"8️⃣","nine":"9️⃣","keycap_ten":"🔟","hash":"#️⃣","asterisk":"*️⃣","arrow_forward":"▶️","pause_button":"⏸","play_or_pause_button":"⏯","stop_button":"⏹","record_button":"⏺","next_track_button":"⏭","previous_track_button":"⏮","fast_forward":"⏩","rewind":"⏪","arrow_double_up":"⏫","arrow_double_down":"⏬","arrow_backward":"◀️","arrow_up_small":"🔼","arrow_down_small":"🔽","arrow_right":"➡️","arrow_left":"⬅️","arrow_up":"⬆️","arrow_down":"⬇️","arrow_upper_right":"↗️","arrow_lower_right":"↘️","arrow_lower_left":"↙️","arrow_upper_left":"↖️","arrow_up_down":"↕️","left_right_arrow":"↔️","arrow_right_hook":"↪️","leftwards_arrow_with_hook":"↩️","arrow_heading_up":"⤴️","arrow_heading_down":"⤵️","twisted_rightwards_arrows":"🔀","repeat":"🔁","repeat_one":"🔂","arrows_counterclockwise":"🔄","arrows_clockwise":"🔃","musical_note":"🎵","notes":"🎶","heavy_plus_sign":"➕","heavy_minus_sign":"➖","heavy_division_sign":"➗","heavy_multiplication_x":"✖️","heavy_dollar_sign":"💲","currency_exchange":"💱","tm":"™️","copyright":"©️","registered":"®️","wavy_dash":"〰️","curly_loop":"➰","loop":"➿","end":"🔚","back":"🔙","on":"🔛","top":"🔝","soon":"🔜","heavy_check_mark":"✔️","ballot_box_with_check":"☑️","radio_button":"🔘","white_circle":"⚪️","black_circle":"⚫️","red_circle":"🔴","large_blue_circle":"🔵","small_red_triangle":"🔺","small_red_triangle_down":"🔻","small_orange_diamond":"🔸","small_blue_diamond":"🔹","large_orange_diamond":"🔶","large_blue_diamond":"🔷","white_square_button":"🔳","black_square_button":"🔲","black_small_square":"▪️","white_small_square":"▫️","black_medium_small_square":"◾️","white_medium_small_square":"◽️","black_medium_square":"◼️","white_medium_square":"◻️","black_large_square":"⬛️","white_large_square":"⬜️","speaker":"🔈","mute":"🔇","sound":"🔉","loud_sound":"🔊","bell":"🔔","no_bell":"🔕","mega":"📣","loudspeaker":"📢","eye_speech_bubble":"👁‍🗨","speech_balloon":"💬","thought_balloon":"💭","right_anger_bubble":"🗯","spades":"♠️","clubs":"♣️","hearts":"♥️","diamonds":"♦️","black_joker":"🃏","flower_playing_cards":"🎴","mahjong":"🀄️","clock1":"🕐","clock2":"🕑","clock3":"🕒","clock4":"🕓","clock5":"🕔","clock6":"🕕","clock7":"🕖","clock8":"🕗","clock9":"🕘","clock10":"🕙","clock11":"🕚","clock12":"🕛","clock130":"🕜","clock230":"🕝","clock330":"🕞","clock430":"🕟","clock530":"🕠","clock630":"🕡","clock730":"🕢","clock830":"🕣","clock930":"🕤","clock1030":"🕥","clock1130":"🕦","clock1230":"🕧","white_flag":"🏳️","black_flag":"🏴","checkered_flag":"🏁","triangular_flag_on_post":"🚩","rainbow_flag":"🏳️‍🌈","afghanistan":"🇦🇫","aland_islands":"🇦🇽","albania":"🇦🇱","algeria":"🇩🇿","american_samoa":"🇦🇸","andorra":"🇦🇩","angola":"🇦🇴","anguilla":"🇦🇮","antarctica":"🇦🇶","antigua_barbuda":"🇦🇬","argentina":"🇦🇷","armenia":"🇦🇲","aruba":"🇦🇼","australia":"🇦🇺","austria":"🇦🇹","azerbaijan":"🇦🇿","bahamas":"🇧🇸","bahrain":"🇧🇭","bangladesh":"🇧🇩","barbados":"🇧🇧","belarus":"🇧🇾","belgium":"🇧🇪","belize":"🇧🇿","benin":"🇧🇯","bermuda":"🇧🇲","bhutan":"🇧🇹","bolivia":"🇧🇴","caribbean_netherlands":"🇧🇶","bosnia_herzegovina":"🇧🇦","botswana":"🇧🇼","brazil":"🇧🇷","british_indian_ocean_territory":"🇮🇴","british_virgin_islands":"🇻🇬","brunei":"🇧🇳","bulgaria":"🇧🇬","burkina_faso":"🇧🇫","burundi":"🇧🇮","cape_verde":"🇨🇻","cambodia":"🇰🇭","cameroon":"🇨🇲","canada":"🇨🇦","canary_islands":"🇮🇨","cayman_islands":"🇰🇾","central_african_republic":"🇨🇫","chad":"🇹🇩","chile":"🇨🇱","cn":"🇨🇳","christmas_island":"🇨🇽","cocos_islands":"🇨🇨","colombia":"🇨🇴","comoros":"🇰🇲","congo_brazzaville":"🇨🇬","congo_kinshasa":"🇨🇩","cook_islands":"🇨🇰","costa_rica":"🇨🇷","cote_divoire":"🇨🇮","croatia":"🇭🇷","cuba":"🇨🇺","curacao":"🇨🇼","cyprus":"🇨🇾","czech_republic":"🇨🇿","denmark":"🇩🇰","djibouti":"🇩🇯","dominica":"🇩🇲","dominican_republic":"🇩🇴","ecuador":"🇪🇨","egypt":"🇪🇬","el_salvador":"🇸🇻","equatorial_guinea":"🇬🇶","eritrea":"🇪🇷","estonia":"🇪🇪","ethiopia":"🇪🇹","eu":"🇪🇺","european_union":"🇪🇺","falkland_islands":"🇫🇰","faroe_islands":"🇫🇴","fiji":"🇫🇯","finland":"🇫🇮","fr":"🇫🇷","french_guiana":"🇬🇫","french_polynesia":"🇵🇫","french_southern_territories":"🇹🇫","gabon":"🇬🇦","gambia":"🇬🇲","georgia":"🇬🇪","de":"🇩🇪","ghana":"🇬🇭","gibraltar":"🇬🇮","greece":"🇬🇷","greenland":"🇬🇱","grenada":"🇬🇩","guadeloupe":"🇬🇵","guam":"🇬🇺","guatemala":"🇬🇹","guernsey":"🇬🇬","guinea":"🇬🇳","guinea_bissau":"🇬🇼","guyana":"🇬🇾","haiti":"🇭🇹","honduras":"🇭🇳","hong_kong":"🇭🇰","hungary":"🇭🇺","iceland":"🇮🇸","india":"🇮🇳","indonesia":"🇮🇩","iran":"🇮🇷","iraq":"🇮🇶","ireland":"🇮🇪","isle_of_man":"🇮🇲","israel":"🇮🇱","it":"🇮🇹","jamaica":"🇯🇲","jp":"🇯🇵","crossed_flags":"🎌","jersey":"🇯🇪","jordan":"🇯🇴","kazakhstan":"🇰🇿","kenya":"🇰🇪","kiribati":"🇰🇮","kosovo":"🇽🇰","kuwait":"🇰🇼","kyrgyzstan":"🇰🇬","laos":"🇱🇦","latvia":"🇱🇻","lebanon":"🇱🇧","lesotho":"🇱🇸","liberia":"🇱🇷","libya":"🇱🇾","liechtenstein":"🇱🇮","lithuania":"🇱🇹","luxembourg":"🇱🇺","macau":"🇲🇴","macedonia":"🇲🇰","madagascar":"🇲🇬","malawi":"🇲🇼","malaysia":"🇲🇾","maldives":"🇲🇻","mali":"🇲🇱","malta":"🇲🇹","marshall_islands":"🇲🇭","martinique":"🇲🇶","mauritania":"🇲🇷","mauritius":"🇲🇺","mayotte":"🇾🇹","mexico":"🇲🇽","micronesia":"🇫🇲","moldova":"🇲🇩","monaco":"🇲🇨","mongolia":"🇲🇳","montenegro":"🇲🇪","montserrat":"🇲🇸","morocco":"🇲🇦","mozambique":"🇲🇿","myanmar":"🇲🇲","namibia":"🇳🇦","nauru":"🇳🇷","nepal":"🇳🇵","netherlands":"🇳🇱","new_caledonia":"🇳🇨","new_zealand":"🇳🇿","nicaragua":"🇳🇮","niger":"🇳🇪","nigeria":"🇳🇬","niue":"🇳🇺","norfolk_island":"🇳🇫","northern_mariana_islands":"🇲🇵","north_korea":"🇰🇵","norway":"🇳🇴","oman":"🇴🇲","pakistan":"🇵🇰","palau":"🇵🇼","palestinian_territories":"🇵🇸","panama":"🇵🇦","papua_new_guinea":"🇵🇬","paraguay":"🇵🇾","peru":"🇵🇪","philippines":"🇵🇭","pitcairn_islands":"🇵🇳","poland":"🇵🇱","portugal":"🇵🇹","puerto_rico":"🇵🇷","qatar":"🇶🇦","reunion":"🇷🇪","romania":"🇷🇴","ru":"🇷🇺","rwanda":"🇷🇼","st_barthelemy":"🇧🇱","st_helena":"🇸🇭","st_kitts_nevis":"🇰🇳","st_lucia":"🇱🇨","st_pierre_miquelon":"🇵🇲","st_vincent_grenadines":"🇻🇨","samoa":"🇼🇸","san_marino":"🇸🇲","sao_tome_principe":"🇸🇹","saudi_arabia":"🇸🇦","senegal":"🇸🇳","serbia":"🇷🇸","seychelles":"🇸🇨","sierra_leone":"🇸🇱","singapore":"🇸🇬","sint_maarten":"🇸🇽","slovakia":"🇸🇰","slovenia":"🇸🇮","solomon_islands":"🇸🇧","somalia":"🇸🇴","south_africa":"🇿🇦","south_georgia_south_sandwich_islands":"🇬🇸","kr":"🇰🇷","south_sudan":"🇸🇸","es":"🇪🇸","sri_lanka":"🇱🇰","sudan":"🇸🇩","suriname":"🇸🇷","swaziland":"🇸🇿","sweden":"🇸🇪","switzerland":"🇨🇭","syria":"🇸🇾","taiwan":"🇹🇼","tajikistan":"🇹🇯","tanzania":"🇹🇿","thailand":"🇹🇭","timor_leste":"🇹🇱","togo":"🇹🇬","tokelau":"🇹🇰","tonga":"🇹🇴","trinidad_tobago":"🇹🇹","tunisia":"🇹🇳","tr":"🇹🇷","turkmenistan":"🇹🇲","turks_caicos_islands":"🇹🇨","tuvalu":"🇹🇻","uganda":"🇺🇬","ukraine":"🇺🇦","united_arab_emirates":"🇦🇪","gb":"🇬🇧","uk":"🇬🇧","us":"🇺🇸","us_virgin_islands":"🇻🇮","uruguay":"🇺🇾","uzbekistan":"🇺🇿","vanuatu":"🇻🇺","vatican_city":"🇻🇦","venezuela":"🇻🇪","vietnam":"🇻🇳","wallis_futuna":"🇼🇫","western_sahara":"🇪🇭","yemen":"🇾🇪","zambia":"🇿🇲","zimbabwe":"🇿🇼"}

/***/ }),
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(172)
  __webpack_require__(173)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(98),
  /* template */
  __webpack_require__(295),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a71bf272",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(161)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(99),
  /* template */
  __webpack_require__(284),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1f449128",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(166)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(100),
  /* template */
  __webpack_require__(289),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6293d840",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(160)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(101),
  /* template */
  __webpack_require__(283),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(174)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(102),
  /* template */
  __webpack_require__(296),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(169)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(103),
  /* template */
  __webpack_require__(292),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-745ed186",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(170)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(104),
  /* template */
  __webpack_require__(293),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(171)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(105),
  /* template */
  __webpack_require__(294),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(165)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(106),
  /* template */
  __webpack_require__(288),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(162)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(107),
  /* template */
  __webpack_require__(285),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(164)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(108),
  /* template */
  __webpack_require__(287),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 283 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jumbotron"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "brandname"
  }, [_vm._v("Flipcards")]), _vm._v(" "), _c('h1', [_vm._v("Digital Index Cards")]), _vm._v(" "), _c('p', [_vm._v("Study effectively with online Index Cards, synced in real time across all your devices.")]), _vm._v(" "), _c('div', {
    staticClass: "ctas"
  }, [_c('router-link', {
    staticClass: "button acc",
    attrs: {
      "to": {
        name: 'signup'
      }
    }
  }, [_vm._v("Sign up")]), _vm._v(" "), _c('router-link', {
    staticClass: "button prim",
    attrs: {
      "to": {
        name: 'signin'
      }
    }
  }, [_vm._v("Sign in")])], 1), _vm._v("\n    Or "), _c('a', {
    staticClass: "local-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.signInLocally.apply(null, arguments)
      }
    }
  }, [_vm._v("sign In locally")]), _vm._v(" and add synchronization later.\n  ")])])
},staticRenderFns: []}

/***/ }),
/* 284 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "outer"
  }, [_c('div', {
    staticClass: "card-wrapper",
    class: {
      'invisible': _vm.viewBack,
      'visible': !_vm.viewBack
    }
  }, [_c('section', {
    staticClass: "front card",
    style: ({
      backgroundColor: _vm.color
    })
  }, [_c('div', {
    staticClass: "front"
  }, [_vm._t("header"), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._t("frontContent")], 2), _vm._v(" "), _c('div', {
    staticClass: "flipper no-select",
    on: {
      "click": function($event) {
        _vm.viewBack = !_vm.viewBack
      }
    }
  }, [_c('div', {
    staticClass: "in-flipper"
  }, [_vm._v("Click / Tap to flip!")]), _vm._v(" "), _c('Tooltip', [_vm._v("↑ or ↓")])], 1)], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "card-wrapper",
    class: {
      'visible': _vm.viewBack,
      'invisible': !_vm.viewBack
    }
  }, [_c('section', {
    staticClass: "back card",
    style: ({
      backgroundColor: _vm.color
    })
  }, [_c('div', {
    staticClass: "back"
  }, [_vm._t("headerBack"), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._t("backContent")], 2), _vm._v(" "), _c('div', {
    staticClass: "flipper no-select",
    on: {
      "click": function($event) {
        _vm.viewBack = !_vm.viewBack
      }
    }
  }, [_c('div', {
    staticClass: "in-flipper"
  }, [_vm._v("Click / Tap to flip!")])])], 2)])])])
},staticRenderFns: []}

/***/ }),
/* 285 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Topbar'), _vm._v(" "), _c('fieldset', {
    staticClass: "signin-form"
  }, [_c('legend', [_vm._v("Sign in")]), _vm._v(" "), _c('button', {
    staticClass: "google-btn",
    staticStyle: {
      "width": "100%"
    },
    on: {
      "click": function($event) {
        return _vm.signinGoogle()
      }
    }
  }, [_c('img', {
    staticClass: "idp-btn-img",
    attrs: {
      "src": "/static/img/icons/google-g-logo.svg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "idp-btn-text"
  }, [_vm._v("\n        sign in with google\n      ")])]), _vm._v(" "), _c('h4', [_vm._v("or using your e-mail")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.signin.apply(null, arguments)
      }
    }
  }, [_c('label', {
    attrs: {
      "for": "signin-email"
    }
  }, [_vm._v("E-Mail")]), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "full-width",
    attrs: {
      "type": "email",
      "id": "signin-email",
      "placeholder": "tom@aol.com",
      "required": ""
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _c('br'), _vm._v(" "), _c('label', {
    attrs: {
      "for": "signin-pw"
    }
  }, [_vm._v("Password")]), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "full-width",
    attrs: {
      "type": "password",
      "id": "signin-pw",
      "placeholder": "**************",
      "required": ""
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "button acc",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Sign in")]), _vm._v(" "), _c('br'), _c('br'), _vm._v("\n      Forgot your password?\n      "), _c('router-link', {
    attrs: {
      "to": {
        name: 'pwreset'
      }
    }
  }, [_vm._v("Reset Password")]), _vm._v(" "), _c('br'), _c('br'), _vm._v("\n      Have no account?\n      "), _c('router-link', {
    attrs: {
      "to": {
        name: 'signup'
      }
    }
  }, [_vm._v("Sign up")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 286 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-view')
},staticRenderFns: []}

/***/ }),
/* 287 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Topbar'), _vm._v(" "), _c('fieldset', {
    staticClass: "signup-form"
  }, [_c('legend', [_vm._v("Sign up")]), _vm._v(" "), _c('button', {
    staticClass: "google-btn",
    staticStyle: {
      "width": "100%"
    },
    on: {
      "click": function($event) {
        return _vm.signupGoogle()
      }
    }
  }, [_c('img', {
    staticClass: "idp-btn-img",
    attrs: {
      "src": "/static/img/icons/google-g-logo.svg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "idp-btn-text"
  }, [_vm._v("\n        sign in with google\n      ")])]), _vm._v(" "), _c('h4', [_vm._v("or using your e-mail")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.signup()
      }
    }
  }, [_c('label', {
    attrs: {
      "for": "signup-email"
    }
  }, [_vm._v("E-Mail")]), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "full-width",
    attrs: {
      "type": "email",
      "id": "signup-email",
      "placeholder": "tom@aol.com",
      "required": ""
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group full-width",
    class: {
      invalid: !_vm.passwordPatternMatch
    }
  }, [_c('label', {
    attrs: {
      "for": "signup-pw"
    }
  }, [_vm._v("Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "full-width",
    attrs: {
      "type": "password",
      "id": "signup-pw2",
      "pattern": ".{6,}",
      "placeholder": "**************",
      "required": ""
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "error"
  }, [_vm._v("Passwords should have at least 6 characters.")])]), _vm._v(" "), _c('div', {
    staticClass: "input-group full-width",
    class: {
      invalid: !_vm.passwordsMatch
    }
  }, [_c('label', {
    attrs: {
      "for": "signup-pw2"
    }
  }, [_vm._v("Repeat Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passwordRetype),
      expression: "passwordRetype"
    }],
    staticClass: "full-width",
    attrs: {
      "type": "password",
      "id": "signup-pw2",
      "pattern": ".{6,}",
      "placeholder": "**************",
      "required": ""
    },
    domProps: {
      "value": (_vm.passwordRetype)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.passwordRetype = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "error"
  }, [_vm._v("Passwords don't match.")])]), _vm._v(" "), _c('button', {
    staticClass: "button acc",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "submit",
      "disabled": !_vm.passwordsMatch || !_vm.passwordPatternMatch
    }
  }, [_vm._v("Sign up")]), _vm._v(" "), _c('br'), _c('br'), _vm._v("\n      Have an account already?\n      "), _c('router-link', {
    attrs: {
      "to": {
        name: 'signin'
      }
    }
  }, [_vm._v("Sign in")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 288 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Topbar', {
    attrs: {
      "loggedIn": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.transitionName
    }
  }, [_c('router-view')], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 289 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [_c('h1', {
    staticClass: "no-select",
    staticStyle: {
      "margin": "24px"
    }
  }, [_vm._v(_vm._s(_vm.deck.name))]), _vm._v(" "), (_vm.cards.length > 0) ? _c('section', {
    staticClass: "cardlist"
  }, [_c('transition-group', {
    attrs: {
      "name": "card"
    }
  }, _vm._l((_vm.cards), function(card) {
    return _c('router-link', {
      key: card['.key'],
      staticClass: "card",
      class: {
        selected: _vm.selectedCards[card['.key']]
      },
      style: ({
        backgroundColor: card.color
      }),
      attrs: {
        "to": {
          name: 'card',
          params: {
            deckId: _vm.deckId,
            cardId: card['.key']
          }
        }
      }
    }, [_c('h2', {
      staticClass: "title"
    }, [_vm._v(_vm._s(card.title))]), _vm._v(" "), _c('hr'), _vm._v(" "), (!_vm.selectedCards[card['.key']]) ? _c('a', {
      staticStyle: {
        "color": "#040",
        "font-size": "0.8rem"
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.selectCard(card['.key'])
        }
      }
    }, [_vm._v("select")]) : _vm._e(), _vm._v(" "), (_vm.selectedCards[card['.key']]) ? _c('a', {
      staticStyle: {
        "color": "#a33",
        "font-size": "0.8rem"
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.deselectCard(card['.key'])
        }
      }
    }, [_vm._v("deselect")]) : _vm._e()])
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.cards.length === 0) ? _c('div', {
    staticClass: "no-cards no-select"
  }, [_vm._v("\n    You have no cards in this deck so far. Click "), _vm._m(0), _vm._v(" to add the first one.\n  ")]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('small', [_c('strong', [_vm._v("ADD CARD")])])
}]}

/***/ }),
/* 290 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "md-tooltip",
    class: _vm.classes,
    style: (_vm.style)
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 291 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "topbar no-select",
    class: {
      contextual: _vm.contextual
    }
  }, [_c('a', {
    staticClass: "topbar-backbtn",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goBack.apply(null, arguments)
      }
    }
  }, [_c('transition', {
    attrs: {
      "name": "homeicon"
    }
  }, [(!_vm.canGoBack && !_vm.contextual) ? _c('img', {
    attrs: {
      "src": "/static/img/icons/android-chrome-192x192.png"
    }
  }) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "backicon"
    }
  }, [(_vm.canGoBack && !_vm.contextual) ? _c('svg', {
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#FFFFFF",
      "d": "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"
    }
  })]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "backicon"
    }
  }, [(_vm.contextual) ? _c('svg', {
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#FFFFFF",
      "d": "M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"
    }
  })]) : _vm._e()])], 1), _vm._v(" "), (!_vm.contextual) ? _c('span', {
    staticClass: "topbar-title"
  }, [_vm._v("Flipcards")]) : _vm._e(), _vm._v(" "), (_vm.contextual) ? _c('span', {
    staticClass: "topbar-title"
  }, [_vm._v(_vm._s(_vm.contextualTitle))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "links-direct"
  }, [_vm._l((_vm.items), function(item) {
    return _c('button', {
      staticClass: "link",
      on: {
        "click": function($event) {
          return _vm.itemClicked(item.id)
        }
      }
    }, [_c('svg', {
      staticClass: "icon",
      attrs: {
        "viewBox": "0 0 24 24"
      }
    }, [_c('path', {
      attrs: {
        "fill": "#ffffff",
        "d": item.svgPath
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.text))]), _vm._v(" "), (item.shortcut) ? _c('Tooltip', [_vm._v(_vm._s(item.shortcut))]) : _vm._e()], 1)
  }), _vm._v(" "), (_vm.signedIn && !_vm.contextual) ? _c('button', {
    staticClass: "link",
    on: {
      "click": _vm.signOut
    }
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#ffffff",
      "d": "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("Sign Out")])]) : _vm._e(), _vm._v(" "), (_vm.items.length > 0 || _vm.signedIn) ? _c('button', {
    staticClass: "link",
    on: {
      "click": function($event) {
        _vm.menuOpen = !_vm.menuOpen
      }
    }
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#ffffff",
      "d": "M12,16A2,2 0 0,1 14,18A2,2 0 0,1 12,20A2,2 0 0,1 10,18A2,2 0 0,1 12,16M12,10A2,2 0 0,1 14,12A2,2 0 0,1 12,14A2,2 0 0,1 10,12A2,2 0 0,1 12,10M12,4A2,2 0 0,1 14,6A2,2 0 0,1 12,8A2,2 0 0,1 10,6A2,2 0 0,1 12,4Z"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("Menu")])]) : _vm._e()], 2), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "overflow"
    }
  }, [(_vm.menuOpen) ? _c('div', {
    staticClass: "overflow-menu"
  }, [_c('div', {
    staticClass: "overlay",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.menuOpen = !_vm.menuOpen
      }
    }
  }), _vm._v(" "), _vm._l((_vm.items), function(item) {
    return _c('button', {
      staticClass: "link",
      on: {
        "click": function($event) {
          return _vm.itemClicked(item.id)
        }
      }
    }, [_c('svg', {
      staticClass: "icon",
      attrs: {
        "viewBox": "0 0 24 24"
      }
    }, [_c('path', {
      attrs: {
        "d": item.svgPath
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.text))]), _vm._v(" "), (item.shortcut) ? _c('Tooltip', [_vm._v(_vm._s(item.shortcut))]) : _vm._e()], 1)
  }), _vm._v(" "), (_vm.signedIn && !_vm.contextual) ? _c('button', {
    staticClass: "link",
    on: {
      "click": _vm.signOut
    }
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("Sign Out")])]) : _vm._e()], 2) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 292 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [(_vm.open) ? _c('div', {
    staticClass: "background-fill",
    on: {
      "click": function($event) {
        return _vm.$emit('cancel')
      }
    }
  }, [_c('div', {
    staticClass: "modal",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _vm._t("default"), _vm._v(" "), _c('div', {
    staticClass: "buttons"
  }, [_c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        return _vm.$emit('cancel')
      }
    }
  }, [_vm._v(_vm._s(_vm.cancelText))]), _vm._v(" "), _c('button', {
    staticClass: "button acc",
    on: {
      "click": function($event) {
        return _vm.$emit('ok')
      }
    }
  }, [_vm._v(_vm._s(_vm.okText))])])], 2)]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 293 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Topbar'), _vm._v(" "), (!_vm.sent) ? _c('fieldset', {
    staticClass: "signin-form"
  }, [_c('legend', [_vm._v("Password reset")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.resetpw.apply(null, arguments)
      }
    }
  }, [_c('label', {
    attrs: {
      "for": "signin-email"
    }
  }, [_vm._v("E-Mail")]), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "full-width",
    attrs: {
      "type": "email",
      "id": "signin-email",
      "placeholder": "tom@aol.com",
      "required": ""
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "button acc",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Reset Password")]), _vm._v(" "), _c('br'), _c('br'), _vm._v("\n      Still remember your password?\n      "), _c('router-link', {
    attrs: {
      "to": {
        name: 'signin'
      }
    }
  }, [_vm._v("Sign in")]), _vm._v(" "), _c('br'), _c('br'), _vm._v("\n      Have no account?\n      "), _c('router-link', {
    attrs: {
      "to": {
        name: 'signup'
      }
    }
  }, [_vm._v("Sign up")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.sent) ? _c('fieldset', {
    staticClass: "signin-form"
  }, [_c('legend', [_vm._v("Password reset")]), _vm._v(" "), _c('p', [_vm._v("\n      A password reset link has been sent to your E-Mail inbox.\n    ")])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 294 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [_c('h1', {
    staticClass: "no-select",
    staticStyle: {
      "margin": "24px"
    }
  }, [_vm._v("Settings")]), _vm._v(" "), (_vm.userIsLocal) ? _c('div', {
    staticClass: "settings-panel"
  }, [_c('h2', {
    staticClass: "no-select"
  }, [_vm._v("Create online Account")]), _vm._v(" "), _c('p', {
    staticClass: "no-select"
  }, [_vm._v("\n      An online account allows you to snychronize your Decks between multiple devices.\n      This allows a better workflow, like editing cards on a computer and then using\n      them on your phone. If you don't active an online account, your data will still\n      be stored safely on your current device.\n    ")]), _vm._v(" "), _c('button', {
    staticClass: "google-btn",
    staticStyle: {
      "width": "100%"
    },
    on: {
      "click": function($event) {
        return _vm.signupGoogle()
      }
    }
  }, [_c('img', {
    staticClass: "idp-btn-img",
    attrs: {
      "src": "/static/img/icons/google-g-logo.svg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "idp-btn-text no-select"
  }, [_vm._v("\n        sign in with google\n      ")])]), _vm._v(" "), _c('h4', {
    staticClass: "no-select"
  }, [_vm._v("or using your e-mail")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.signup()
      }
    }
  }, [_c('label', {
    attrs: {
      "for": "signup-email"
    }
  }, [_vm._v("E-Mail")]), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "full-width",
    attrs: {
      "type": "email",
      "id": "signup-email",
      "placeholder": "tom@aol.com",
      "required": ""
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group full-width",
    class: {
      invalid: !_vm.passwordPatternMatch
    }
  }, [_c('label', {
    attrs: {
      "for": "signup-pw"
    }
  }, [_vm._v("Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "full-width",
    attrs: {
      "type": "password",
      "id": "signup-pw2",
      "pattern": ".{6,}",
      "placeholder": "**************",
      "required": ""
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "error"
  }, [_vm._v("Passwords should have at least 6 characters.")])]), _vm._v(" "), _c('div', {
    staticClass: "input-group full-width",
    class: {
      invalid: !_vm.passwordsMatch
    }
  }, [_c('label', {
    attrs: {
      "for": "signup-pw2"
    }
  }, [_vm._v("Repeat Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passwordRetype),
      expression: "passwordRetype"
    }],
    staticClass: "full-width",
    attrs: {
      "type": "password",
      "id": "signup-pw2",
      "pattern": ".{6,}",
      "placeholder": "**************",
      "required": ""
    },
    domProps: {
      "value": (_vm.passwordRetype)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.passwordRetype = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "error"
  }, [_vm._v("Passwords don't match.")])]), _vm._v(" "), _c('button', {
    staticClass: "button acc",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "submit",
      "disabled": !_vm.passwordsMatch || !_vm.passwordPatternMatch
    }
  }, [_vm._v("Sign up")])])]) : _vm._e(), _vm._v(" "), (!_vm.userIsLocal && _vm.isFirebaseEmailUser) ? _c('div', {
    staticClass: "settings-panel"
  }, [_c('h2', [_vm._v("Change Password")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "settings-panel no-select"
  }, [_c('h2', [_vm._v("Delete Account")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('button', {
    staticClass: "button acc",
    on: {
      "click": _vm.deleteAccount
    }
  }, [_vm._v("delete Account")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Warning:")]), _vm._v(" Clicking here deletes all your decks forever.")])
}]}

/***/ }),
/* 295 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [(!_vm.editing) ? _c('div', {
    staticClass: "nav-btns"
  }, [_c('router-link', {
    staticClass: "nav-btn prev",
    class: {
      visible: _vm.navIds.prev
    },
    attrs: {
      "to": {
        name: 'card',
        params: {
          deckId: _vm.deckId,
          cardId: _vm.navIds.prev || '0'
        },
        query: _vm.$route.query
      }
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#000000",
      "d": "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
    }
  })]), _vm._v(" "), _c('Tooltip', [_vm._v("or press ←")])], 1), _vm._v(" "), _c('span', {
    staticClass: "spacer"
  }), _vm._v(" "), _c('router-link', {
    staticClass: "nav-btn next",
    class: {
      visible: _vm.navIds.next
    },
    attrs: {
      "to": {
        name: 'card',
        params: {
          deckId: _vm.deckId,
          cardId: _vm.navIds.next || '0'
        },
        query: _vm.$route.query
      }
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#000000",
      "d": "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
    }
  })]), _vm._v(" "), _c('Tooltip', [_vm._v("or press →")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.editing) ? _c('div', {
    staticClass: "color-picker"
  }, [_c('span', {
    staticClass: "color",
    class: {
      picked: _vm.eColor === '#ffed96'
    },
    staticStyle: {
      "background-color": "#ffed96"
    },
    on: {
      "click": function($event) {
        _vm.eColor = '#ffed96'
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "color",
    class: {
      picked: _vm.eColor === '#adebad'
    },
    staticStyle: {
      "background-color": "#adebad"
    },
    on: {
      "click": function($event) {
        _vm.eColor = '#adebad'
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "color",
    class: {
      picked: _vm.eColor === '#ffb399'
    },
    staticStyle: {
      "background-color": "#ffb399"
    },
    on: {
      "click": function($event) {
        _vm.eColor = '#ffb399'
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "color",
    class: {
      picked: _vm.eColor === '#bfb3ff'
    },
    staticStyle: {
      "background-color": "#bfb3ff"
    },
    on: {
      "click": function($event) {
        _vm.eColor = '#bfb3ff'
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.editing) ? _c('div', {
    staticClass: "markdown-link-container"
  }, [_vm._v("\n    You can use\n    "), _c('a', {
    attrs: {
      "href": "https://github.com/adam-p/markdown-here/wiki/Markdown-Cheatsheet",
      "target": "_blank"
    }
  }, [_vm._v("Markdown")]), _vm._v("\n    to style your text.\n  ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.backDefault),
      expression: "backDefault"
    }],
    attrs: {
      "type": "checkbox",
      "id": "backDefaultCb"
    },
    domProps: {
      "checked": Array.isArray(_vm.backDefault) ? _vm._i(_vm.backDefault, null) > -1 : (_vm.backDefault)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.backDefault,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.backDefault = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.backDefault = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.backDefault = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "backDefaultCb"
    }
  }, [_vm._v("Show back first")])]), _vm._v(" "), _c('Cardview', {
    ref: "card",
    staticClass: "cardview",
    attrs: {
      "color": _vm.cardcolor
    }
  }, [(!_vm.editing) ? _c('h1', {
    staticClass: "heading",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v(_vm._s(_vm.card.title))]) : _vm._e(), _vm._v(" "), (_vm.editing) ? _c('div', {
    staticClass: "heading-input-container",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.eTitle),
      expression: "eTitle"
    }],
    ref: "etitle",
    staticClass: "heading-input",
    attrs: {
      "type": "text",
      "placeholder": "Title"
    },
    domProps: {
      "value": (_vm.eTitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.eTitle = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.editing) ? _c('Markdown', {
    attrs: {
      "slot": "frontContent",
      "source": _vm.card.front
    },
    slot: "frontContent"
  }) : _vm._e(), _vm._v(" "), (_vm.editing) ? _c('div', {
    staticClass: "content-input-container",
    attrs: {
      "slot": "frontContent"
    },
    slot: "frontContent"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.eFront),
      expression: "eFront"
    }],
    staticClass: "content-input",
    attrs: {
      "placeholder": "Front Content"
    },
    domProps: {
      "value": (_vm.eFront)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.eFront = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('h2', {
    staticClass: "heading",
    attrs: {
      "slot": "headerBack"
    },
    slot: "headerBack"
  }, [_vm._v(_vm._s(_vm.card.title))]), _vm._v(" "), (!_vm.editing) ? _c('Markdown', {
    attrs: {
      "slot": "backContent",
      "source": _vm.card.back
    },
    slot: "backContent"
  }) : _vm._e(), _vm._v(" "), (_vm.editing) ? _c('div', {
    staticClass: "content-input-container",
    attrs: {
      "slot": "backContent"
    },
    slot: "backContent"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.eBack),
      expression: "eBack"
    }],
    staticClass: "content-input",
    attrs: {
      "placeholder": "Back Content"
    },
    domProps: {
      "value": (_vm.eBack)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.eBack = $event.target.value
      }
    }
  })]) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 296 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [(_vm.userIsLocal) ? _c('div', {
    staticClass: "user-local-container"
  }, [_c('p', [_c('router-link', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple"
    }],
    staticClass: "link",
    attrs: {
      "to": {
        name: 'settings'
      }
    }
  }, [_vm._v("Create an online account")]), _vm._v(" if you want to use your cards across multiple devices.\n    ")], 1)]) : _vm._e(), _vm._v(" "), _c('h1', {
    staticClass: "no-select",
    staticStyle: {
      "margin": "24px"
    }
  }, [_vm._v("Your Decks")]), _vm._v(" "), (_vm.decks.length > 0) ? _c('ul', {
    staticClass: "decklist"
  }, _vm._l((_vm.decks), function(deck) {
    return _c('li', {
      staticClass: "deck"
    }, [_c('button', {
      staticClass: "button img delbtn",
      attrs: {
        "aria-label": "delete deck"
      },
      on: {
        "click": function($event) {
          return _vm.openDeleteDeckModal(deck)
        }
      }
    }, [_c('svg', {
      staticStyle: {
        "width": "24px",
        "height": "24px"
      },
      attrs: {
        "viewBox": "0 0 24 24"
      }
    }, [_c('path', {
      attrs: {
        "fill": "#880000",
        "d": "M19,4H15.5L14.5,3H9.5L8.5,4H5V6H19M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19Z"
      }
    })])]), _vm._v(" "), _c('router-link', {
      attrs: {
        "to": {
          name: 'deck',
          params: {
            deckId: deck['.key']
          }
        }
      }
    }, [_vm._v("\n        " + _vm._s(deck.name)), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "card-count"
    }, [_vm._v(_vm._s(deck.cardCount) + " cards")])])], 1)
  }), 0) : _vm._e(), _vm._v(" "), (_vm.decks.length === 0) ? _c('div', {
    staticClass: "no-decks no-select"
  }, [_vm._v("\n    You have no decks yet. Click "), _vm._m(0), _vm._v(" to create one.\n  ")]) : _vm._e(), _vm._v(" "), _c('Modal', {
    staticClass: "no-select",
    attrs: {
      "open": _vm.createDeckModalOpen,
      "title": "Create a new Deck",
      "cancelText": "cancel",
      "okText": "create Deck"
    },
    on: {
      "ok": function($event) {
        return _vm.createDeck()
      },
      "cancel": function($event) {
        _vm.createDeckModalOpen = false
      }
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.createDeck()
      }
    }
  }, [_c('div', {
    staticClass: "input-group full-width"
  }, [_c('label', {
    attrs: {
      "for": "newdeckname"
    }
  }, [_vm._v("Deck Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newDeckName),
      expression: "newDeckName"
    }],
    ref: "nameInput",
    staticClass: "full-width",
    attrs: {
      "type": "text",
      "id": "newdeckname",
      "placeholder": "electrical engineering",
      "required": ""
    },
    domProps: {
      "value": (_vm.newDeckName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newDeckName = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('Modal', {
    staticClass: "no-select",
    attrs: {
      "open": _vm.deleteDeckModalOpen,
      "title": "Delete Deck",
      "cancelText": "cancel",
      "okText": "delete"
    },
    on: {
      "ok": function($event) {
        return _vm.deleteDeck()
      },
      "cancel": function($event) {
        return _vm.cancelDeleteDeck()
      }
    }
  }, [_vm._v("\n      Really delete " + _vm._s(_vm.toBeDeletedName) + "? This cannot be undone!\n  ")])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('small', [_c('strong', [_vm._v("NEW DECK")])])
}]}

/***/ })
],[93]);


// WEBPACK FOOTER //
// static/js/app.513cf3ff50ed04cd89ac.js